import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import classNames from 'classnames';
import lodashMap from 'lodash/map';
import lodashFilter from 'lodash/filter';
import lodashFind from 'lodash/find';
import upperFirst from 'lodash/upperFirst';
import lowerFirst from 'lodash/lowerFirst';
import ReactTooltip from 'react-tooltip';
import { Link, withRouter } from 'react-router';
import { Field, FieldArray } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb, Tabs, Tab } from 'react-bootstrap';
import { Data } from 'react-data-grid-addons';
import ReactDOM from 'react-dom';
import { Translate, I18n } from 'react-redux-i18n';
import ConfirmModal from 'Common/confirmModal';
import ContentWrapper from '../Layout/ContentWrapper';
import axios from 'axios';

import checkPermissionLocal from '../Common/permissions';
import MixProductAutoSuggest from '../Common/MixProductAutoSuggest';
import MixProductTypeRadios from '../Common/MixProductTypeRadios';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection'
import { InputField, DisabledInputField, ControlledInputField, ControllabledStateInputField } from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import SpinnerButton from '../Common/SpinnerButton';
import VendorForm from '../../containers/Products/vendorForm'
import GroupForm from '../../containers/Products/groupForm'
import EditGroupForm from '../../containers/Products/editGroupForm';
import CategoryForm from '../../containers/Products/categoryForm'
import ProductFormNavigation_1, { productFormNavigation_2 as ProductFormNavigation_2, productFormNavigation_3 as ProductFormNavigation_3 } from '../../containers/Products/productFormNavigation'
import Editor from '../Common/Editor';
import PackageTypes from '../../containers/Products/packageTypes';
import ConfirmActionModal from '../Common/confirmActionModal';
import RichTextEditor from '../Common/RichTextEditor';
import TuiEditor from '../Common/TuiEditor';
import LinkProductsModal from './components/LinkProductsModal';
import ProductImagesTable from './components/ProductImagesTable';
import { fetchMobileDescriptionBoxText } from '../../actions/products_actions';
import checkPermission from '../Common/permissions';
import { fetchPromoDetailsByProduct, savePromotion, deletePromotion, fetchPromoDetails } from '../../actions/promotions_actions';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isSY, isCNT } from '../../actions/root_url';
import SkusTableModal from './components/SkusModal';
import { DisplayCategoryModal } from '../Common/displayCategoryModal';
import ProductMetaInfoModal from './components/ProductMetaInfoModal';
import ESLModal from './components/ESLModal';

import {
  roundUp,
  calculatePriceLevelNormal,
  normalizeFourDecimals,
  calculatePricePercentage,
  priceLevelFieldsMap,
  priceLevelPercentageFieldsMap,
} from '../Common/NumberUtil';
import {
  isIncompleteForm,
  clearForm,
  desiredShapeByQuantity,
  desiredShapeBuyAGetB,
  desiredShapeByTotalPriceProduct,
  desiredShapeByTotalPriceDiscount,
} from '../Sales/PromotionsPage/utils';
import { PromotionSetup, ByQuantityFields, BuyAGetBFields, ByTotalPriceProductFields, EditPromotionModal } from '../Sales/PromotionsPage/components';
import {
  isRivera,
  isElegant,
} from '../../actions/root_url';

const isMyuMyu = ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isHMM = ROOT_API_URL === "https://hmm-scm.truckxi.com/api/" || ROOT_URL === "https://hmm-scm.truckxi.com/api/"
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isCalco = ROOT_API_URL === 'https://calco-scm.truckxi.com/api/' || ROOT_API_URL === 'https://calco-stage.truckxi.com/api/';
const isMMD = ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
const isPTS = ROOT_API_URL === 'https://phantoscope-scm.truckxi.com/api/' || ROOT_URL === 'https://phantoscope-scm.truckxi.com/api/';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_API_URL === 'https://afmstage-scm.truckxi.com/api/' || ROOT_URL === 'https://afmstage-scm.truckxi.com/api/';
const isPS = ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api/' || ROOT_URL === 'https://premiumstella-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
const isTQ = ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/'|| ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
const isFACEX = ROOT_API_URL === "https://facex-scm.truckxi.com/api/" || ROOT_URL === "https://facex-scm.truckxi.com/api/";
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
const isATL = ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || ROOT_URL === 'https://alton-scm.truckxi.com/api/';
const isRS = ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
const isSW = ROOT_API_URL === 'https://snapwise-scm.truckxi.com/api/' || ROOT_URL === 'https://snapwise-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isCS = ROOT_API_URL === 'https://coastsequoia-scm.truckxi.com/api/' || ROOT_URL === 'https://coastsequoia-scm.truckxi.com/api/';
const isLO = ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
const isAmzey = ROOT_API_URL === 'https://amzey-scm.truckxi.com/api/' || ROOT_URL === 'https://amzey-scm.truckxi.com/api/';
const isAPO = ROOT_API_URL === 'https://admin.apoodr.com/api/' || ROOT_URL === 'https://admin.apoodr.com/api/';
const isGS = ROOT_API_URL === 'https://grantstone-scm.truckxi.com/api/' || ROOT_URL === 'https://grantstone-scm.truckxi.com/api/';

const customizedInputStyle = { width: "100%", borderRadius: '2px', border: '1px solid black', backgroundColor: 'rgb(207,216,220)', padding: '0 6px' };

let renderInputField = (props) => {
  const inputClass = classNames({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control')
  return (
    <div>
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      <Input {...props.input} className={inputClass} type="text"/>
    </div>
  )
}

let renderRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value={`${props.labelName}`}/>
      </label>
      <div className="col-xs-2">
        <input {...props.input} type="radio" value="true"
           checked={props.input.value === true || props.input.value === "true"}/>
           <Translate value="yes"/>
      </div>
      <div className="col-xs-2">
        <input {...props.input} type="radio" value="false"
           checked={props.input.value === false || props.input.value === "false"}/>
           <Translate value="no"/>
      </div>
    </div>
  )
}

const Checkbox = props => {
  return (
    <input
      {...props.input}
      type="checkbox"
      value={!props.input.value ? "true" : "false"}
      checked={props.input.value === true || props.input.value === "true"}
      disabled={props.disabled}
    />
  );
}

const renderPriceTypeRadio = props => {
  return (
    <Row style={{ position: "relative", top: "1px" }}>
      <Col xs={5} style={{ padding: 0 }}>
        <input
          {...props.input}
          type="radio"
          value="weight"
          checked={props.input.value === 'weight'}
          disabled={props.disabled}
        />
        <label><Translate value="price_style_1"/></label>
      </Col>
      <Col xs={7} style={{ padding: 0 }}>
        <input
          {...props.input}
          type="radio"
          value="unit"
          checked={props.input.value === 'unit'}
          disabled={props.disabled}
        />
        <label><Translate value="price_style_2"/> </label>
      </Col>
    </Row>
  )
}

let ConvertProductTypeRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-2">
        <Translate value="prod_type" />
      </label>
      <div className="col-xs-3 text-nowrap">
        <input {...props.input} type="radio" value="Fixed"
          checked={props.input.value === "Fixed" || props.input.value.value === "Fixed"}/>
        <Translate value="per-unit"/>
      </div>
      <div className="col-xs-3 text-nowrap">
          <input {...props.input} type="radio" value="Per-Pound"
            checked={props.input.value === "Per-Pound" || props.input.value.value === "Per-Pound"}/>
          <Translate value="per-weight"/>
      </div>
      <div className="col-xs-3 text-nowrap">
          <input {...props.input} type="radio" value="Non-Fixed"
            checked={props.input.value === "Non-Fixed" || props.input.value.value === "Non-Fixed"}/>
          <Translate value="Non-Fixed"/>
      </div>
    </div>
  )
}

let relatedRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value="related" />
      </label>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="true"
          checked={props.input.value === true || props.input.value === "true"}
          disabled={!props.disableIsRelated}
        />
        <Translate value="yes"/>
      </div>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="false"
          checked={props.input.value === false || props.input.value == "false"}
          disabled={!props.disableIsRelated}
        />
        <Translate value="no"/>
      </div>
    </div>
  )
}

let sizeRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value="size" />
      </label>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="true"
          checked={props.input.value === true || props.input.value === "true"}
          disabled={!props.disableIsLarge}
        />
        <Translate value="lg"/>
      </div>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="false"
          checked={props.input.value === false || props.input.value === "false"}
          disabled={!props.disableIsLarge}
        />
        <Translate value="sm"/>
      </div>
    </div>
  )
}

let convertNumRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value="convert_type"/><span className="asteriksReq">*</span>
      </label>
      <div className="col-xs-3 text-nowrap">
        <input {...props.input} type="radio" value="weight"
          checked={props.input.value === "weight"}/>
        <Translate value="by_weight"/>
      </div>
      <div className="col-xs-3 text-nowrap">
        <input {...props.input} type="radio" value="unit"
          checked={props.input.value === "unit"}/>
        <Translate value="by_unit"/>
      </div>
    </div>
  )
}

let renderSaleRadios = props => {
  const titleClass = classNames('col-xs-4')
  return (
    <div id="stopSale" className="form-group" >
      <label className="col-xs-4">
        <input {...props.input} type="radio" value="OnSale"
          checked={props.input.value === "OnSale"}/>
        <Translate value="on_sale"/>
      </label>
      <label className="col-xs-4">
        <input {...props.input} type="radio" value="StopSale"
          checked={props.input.value === "StopSale"}/>
        <Translate value="stop_sale"/>
      </label>
      <label className="col-xs-3 pull-right">
        <input {...props.input} type="radio" value="OnHold"
          checked={props.input.value === "OnHold"}/>
        <Translate value="on_hold"/>
      </label>
    </div>
  )
}

const renderConvertDetailsList = (props) => {
  const { fields } = props;
  return (
      <Row>
        <Col xs={ 12 }>
          <Row>
            <Col xs={ 12 }>
              {fields.map((Product, index) =>
                <div>
                  <Row key={index} className="prod-qty-adjuster">
                    <Col xs={ 12 }>
                      <Row>
                        <label className="col-xs-2"><Translate value="prod_num"/></label>
                        <Col xs={ 3 } className="prod-no-related">
                          <div className="form-group">
                            <div className="col-xs-12">
                            <Field name={`${Product}.ProductNum`} className="control-label" component={ DisabledInputField } />
                            </div>
                          </div>
                        </Col>
                        <Col xs={ 4 } className="convert-qty">
                          <div className="form-group">
                            <div className="col-xs-12">
                              <Field name={`${Product}.PackageSize`} className="control-label" component={ DisabledInputField } />
                            </div>
                          </div>
                        </Col>
                        <Col xs={ 3 } className="convert-qty">
                          <div className="form-group">
                            <div className="col-xs-12">
                              <Field name={`${Product}.ProductType`} className="control-label" component={ DisabledInputField } />
                            </div>
                          </div>
                        </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

// Mix Products field array with multiple products
const renderMixProductArrays = (props) => {
  const { fields, suggestProduct, packageTypeOptions } = props;
  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12} style={{ textAlign: 'right', height: '25px' }}>
            <Button
              style={{ marginBottom: '10px' }}
              bsStyle="primary"
              type="button"
              disabled={!suggestProduct}
              onClick={() => { fields.push({ ProductName: suggestProduct.Name, ProductNum: suggestProduct.ProductNum, ProductSKU: suggestProduct.RefNum }) }}
            >
              <em className="fa fa-plus" />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {!fields.length && <div><Translate value="no_mix_product" /> </div>}
            {fields.map((MixProduct, index) =>
              <Row key={index}>
                <Col xs={12}>
                  <Row className="nonbold-label-description textAlignStyle">
                    <Col sm={4}><Translate value="(ref_no)" /></Col>
                    <Col sm={1}></Col>
                    <Col sm={2}><Translate value="(num)" /></Col>
                    <Col sm={3}><Translate value="(pkg_size)" /></Col>
                    <Col sm={1}></Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <div className="form-group">
                        <div className="col-xs-12">
                          <Field name={`${MixProduct}.ProductSKU`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={1} className="textAlignStyle"><em className="fa fa-times times-sign" /></Col>
                    <Col xs={2}>
                      <div className="form-group">
                        <div className="col-xs-12">
                          <Field name={`${MixProduct}.Quantity`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="form-group">
                        <div className="col-xs-12 select-menu-drop-up">
                          <Field style={{ textAlign: 'left' }} name={`${MixProduct}.MixedUnit`} component={Selection} options={packageTypeOptions} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={1} style={{ position: "relative" }}>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        onClick={() => { fields.remove(index); }} // remove from index
                      >
                        <em className="fa fa-trash" />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

// Vendors should be a field array with multiple vendors.
const renderVendorArrays = (props) => {
  const { fields, vendorNameOptions, vendorNumOptions } = props;
  return (
    <Row>
      <Col xs={ 12 }>
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => { fields.push({})} }   // pushes empty child field onto the end of the array
        >
          <em className="fa fa-plus" />
        </Button>
        <Row>
          <Col xs={ 12 }>
            {!fields.length && <div><Translate value="no_vendor"/> </div>}
            {fields.map((Vendor, index) =>
              <Row key={index}>
                <Col xs={12}>
                  <h4><Translate value="barcode_poundsign"/> {index + 1}</h4>
                  <Row>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="name"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_id`} component={Selection} options={vendorNameOptions}/>
                        </div>
                      </div>
                    </Col>
                    <Col xs={5}>
                      <label className="col-xs-3"><Translate value="num"/></label>
                      <div className="col-xs-9">
                        <Field name={`${Vendor}.Vendor_id`} component={Selection} options={vendorNumOptions}/>
                      </div>
                    </Col>
                    <Col xs={1} style={{position: "relative", left: "-13px"}}>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        onClick={() => { fields.remove(index); }} // remove from index
                      >
                        <em className="fa fa-trash" />
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="barcode"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Code`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="VPN"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_product_num`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

var submitTrue = false;

const languages = [
  {
    label: 'English - EN',
    value: 'EN',
  },
  {
    label: 'Chinese - ZH',
    value: 'ZH',
  },
];
const isSoleStage = function() {
  return ( ROOT_URL === "https://ss-stage.truckxi.com/api/" ||  ROOT_URL === "https://solestage-scm.truckxi.com/api/" )
}
const isBD = function() {
  return ( ROOT_URL === "https://bd-stage.truckxi.com/api/" ||  ROOT_URL === "https://bd-scm.truckxi.com/api/" ) 
}
class ProductForm extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      eslEnabled: false,
      eslModalVisibility: false,
      eslFetchData: null,
      formProps: {},
      confirmModalVisibility: false,
      suggestValue: '',
      productSearchType: 'Name',
      suggestProduct: null,
      MixedProductBaseUnit: null,
      MixedProduct: {
        Unit: null,
        MixedUnit: null,
        ProductName: null,
        ProductNum: null,
        ProductSKU: null,
        Quantity: null,
      },
      skusModal: false,
      vendorOpen: false,
      groupOpen: false,
      categoryOpen: false,
      packageTypeOpen: false,
      mobileDescBoxOpen: false,
      displayCategoryBoxOpen: false,
      addConvertProductsOpen: false,
      checkAuthorizeOpen: false,
      editProductGroup: false,
      vendorValue: null,
      dirty: false,
      p1Percentage: 0,
      p2Percentage: 0,
      p3Percentage: 0,
      p4Percentage: 0,
      p5Percentage: 0,
      priceLv1: 0,
      priceLv2: 0,
      priceLv3: 0,
      priceLv4: 0,
      priceLv5: 0,
      changePrice: true,
      editableProductNum: true,
      crumbStyle: {},
      files: null,
      Product_id: 0,
      showProductCreatedOpen: false,
      productNavigationOpen: [false, false],
      productNavigation_1: {
        ProductCategory1_id: null,
        ProductGroup_id: null,
        ProductNum: null,
        RefNum: null,
        suggestedProdNum: null,
        isLinked: false,
        Name: null,
        Description: null,
        IsLarge: null,
        LastDigit: null,
        isMadePrev: null,
      },
      productNavigation_2: {
        ProdType: null,
        PackageType: null,
        PackageSize_1: null,
        PackageType_2: null,
        PackageSize_2: null,
        MeasureUnit_2: null,
        NetWeight_1: null,
        NetWeight_2: null,
        RefPrice: null,
        LowestSalePrice: null,
      },
      productNavigation_3: {
        ConvertNum: null,
        SmallProdType: null,
        SmallPackageType: null,
        ConvertType: null,
      },
      // promo
      customerList: [],
      warehouseOptions: [],
      startDateSelected: null,
      endDateSelected: null,
      customerGroupSelected: '',
      paymentTypeSelected: '',
      tabsKey: 'ByQuantity',
      selectedProduct: {},
      promotionToEdit: {},
      methodSelected: '',
      discountValue: '',
      discountType: 'Dollar',
      quantityFrom: '',
      quantityTo: '',
      minPurchasePrice: '',
      promotionDetails: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      isLoadingPromotions: false,
      isLoadingSavePromotion: false,
      isLoadingPromoDetails: false,
      promotionDetailsIsLoading: false,
      viewPromotion: false,
      deletePromotionOpen: false,
      editPromotionOpen: false,
      promotionToDeleteId: undefined,

      editRecPermissionOpen: false,
      case: null,

      isLoadingMobileDescBoxText: false,
      mobileDescriptionHTML: '',
      imagesModalOpen: false,
      updatedImage: undefined,
      relatedProducts: [],

      isLoadingCategoryProducts: false,
      isLoadingDisplayCategory: false,
      categoryProducts: [],
      deleteModalOpen: false,
      ProductSKU: '',

      displayCategories: null,
      permissionChecked: false,

      productMetaInfoVisibility: false,
      meta_info: {
        meta_title: '',
        meta_keywords: '',
        meta_description: '',
      },

      customerAltOptions: [],

      PackageTypeC: '',
      productInventoryQty: 0,
    };
    this.openVendor = this.openVendor.bind(this);
    this.closeVendor = this.closeVendor.bind(this);
    this.openGroup = this.openGroup.bind(this);
    this.closeGroup = this.closeGroup.bind(this);
    this.openCategory = this.openCategory.bind(this);
    this.closeCategory = this.closeCategory.bind(this);
    this.handlePercentageChange = this.handlePercentageChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.openShowProductCreated = this.openShowProductCreated.bind(this);
    this.closeShowProductCreated = this.closeShowProductCreated.bind(this);
    this.openPackageType = this.openPackageType.bind(this);
    this.closePackageType = this.closePackageType.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.navigate = this.navigate.bind(this);
    this.saveCurrentModal = this.saveCurrentModal.bind(this);
    this.handleClickNext_1 = this.handleClickNext_1.bind(this);
    this.handleClickPrev_2 = this.handleClickPrev_2.bind(this);
    this.handleClickNext_2 = this.handleClickNext_2.bind(this);
    this.handleClickPrev_3 = this.handleClickPrev_3.bind(this);
    this.closeNavigation = this.closeNavigation.bind(this);
    this.saveProductFormNavigation_3 = this.saveProductFormNavigation_3.bind(this);
    this.handleClickFinish = this.handleClickFinish.bind(this);
    this.selectPackageType = this.selectPackageType.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
  }

  componentWillMount() {
    const { currentProduct } = this.props;
    if (!currentProduct && !this.props.params) {
      this.context.router.push('/products/new');
    }
    if (!currentProduct && this.props.params.id) {
      // this.props.fetchProductDetail(this.props.params.id);
      // alert('no current product');
    }
    // if (currentProduct) {
    // if (this.props.params.id) {
    //   const id = this.props.params.id;
    //   this.props.fetchCategories2();
    //   this.getDisplayCategories(id);
    //   this.props.fetchVendors();
    //   this.props.fetchGroups();
    //   // for facex
    //   this.props.fetchProductInventoryBatches(id)
    //     .then(() => {
    //       this.setState({
    //         productInventoryQty: this.props.productInventory.total_quantity,
    //       });
    //     });
    //   this.props.fetchZones()
    //     .then(() => {
    //       this.props.fetchProductDetail(id)
    //         .then(() => {
    //           this.props.zones.map(zone => {
    //             if (zone.zone_num === this.props.Zone) {
    //               let foundZone = zone;
    //               this.props.setValue("productForm", "Zone", foundZone.zone_num);
    //               this.props.getBinsByZone(foundZone.id, 1);
    //             }
    //             if (zone.zone_num === this.props.Zone2) {
    //               let foundZone2 = zone;
    //               this.props.setValue("productForm", "Zone2", foundZone2.zone_num);
    //               this.props.getBinsByZone(foundZone2.id, 2);
    //             }
    //             if (zone.zone_num === this.props.Zone3) {
    //               let foundZone3 = zone;
    //               this.props.setValue("productForm", "Zone3", foundZone3.zone_num);
    //               this.props.getBinsByZone(foundZone3.id, 3);
    //             }
    //           });
    //         });
    //       });
    //       // if you open one product and then on the same page open another product (go back or go next) the zone sticks around from product to product
    //       // if customer changes price or unrelated item and then saves they save the old ZBL data.
    //       // general product/warehouse inventory search/
    //       this.setState({ editableProductNum: false });
    // } else {
      this.props.fetchCategories2();
      this.props.fetchVendors();
      this.props.fetchGroups();
      this.props.fetchZones()
      this.props.setDefaultOfForm("PriceType", "weight", "productForm")    
      if (isAFG || isMyuMyu || isWecom) {
        this.props.setDefaultOfForm("IsStopSale", "true", "productForm");
        this.props.setDefaultOfForm("IsOverSaleable", "false", "productForm");
      } else {
        this.props.setDefaultOfForm("IsStopSale", "false", "productForm");
        this.props.setDefaultOfForm("IsOverSaleable", "true", "productForm");
      }
      this.props.setDefaultOfForm("IsDiscontinued", "false", "productForm");
      this.props.setDefaultOfForm("IsWholesaleOnly", "false", "productForm");
      this.props.setDefaultOfForm("IsMobile", "false", "productForm");
      if (isEcity) {
        this.props.setDefaultOfForm("IsTaxable", "true", "productForm");
      } else {
        this.props.setDefaultOfForm("IsTaxable", false, "productForm");
      }
      this.props.setDefaultOfForm("IsAllTaxable", "false", "productForm");
      this.props.setDefaultOfForm("IsNonFood", "false", "productForm");
      this.props.setDefaultOfForm("IsSoldNationwide", "false", "productForm");
      this.props.setDefaultOfForm("IsGreatDeal", "false", "productForm");
      this.props.setDefaultOfForm("IsNewArrival", "false", "productForm");
      this.props.setDefaultOfForm("IsProposition65", "false", "productForm");
      this.props.setDefaultOfForm("IsSyncToScales", "false", "productForm");
      this.props.setDefaultOfForm("IsSyncToESL", "false", "productForm");
      this.props.setDefaultOfForm("IsAFGChioce", "false", "productForm");
      this.props.setDefaultOfForm("IsAlcohol", "false", "productForm");
      this.props.setDefaultOfForm("IsB2B", "false", "productForm");
      this.props.setDefaultOfForm("IsB2C", "true", "productForm");
    // }
    if (this.props.location.pathname === "/products/new") {
      this.setState({productNavigationOpen: [true, false]})
    }
    this.props.fetchCRVValues();
    this.props.fetchDefaultBuyers();
    this.props.clearAttachedProductImage();
    this.props.fetchPackageTypes();
    this.props.fetchMeasurementUnit();
    // making a leaving hook to confirm leaving
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    if (this.props.params.id) {
      setTimeout(() => {
          this.props.fetchProductDetail(this.props.params.id, this.props.selectedCompany, this.props.selectedWarehouse)
      }, 1000);
    }





    if (isFBD) {
      this.props.fetchCustomers(true);
    } else {
      this.props.fetchCustomers();
    }
    
    let { customerAltOptions } = this.state;
    if (isABCFF) {
      axios
        .get(
          `${ROOT_URL}v1/customer/?Customer_id__IsActive=1`,
          {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`,},},
        )
        .then(
          (res) => {
            res.data.map(r=>{
              customerAltOptions.push({label: r.Name, value: r.Customer_id});
            });
            console.log("customers ABCFF", customerAltOptions);
            this.setState({customerAltOptions});
          },
          (err) => {
            if (err.data) {
              alert(err.data);
            } else {
              alert("Server issue detected, please contact admin.");
            }
          }
        );

      }

      let { warehouseOptions } = this.state;
      if (isUSPride) {
        axios
        .get(
          `${ROOT_URL}v1/warehouse/`,
          {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`,},},
        )
        .then(
          (res) => {
            res.data.map(r=>{
              warehouseOptions.push({label: r.Name, value: r.Warehouse_id});
            });
            console.log("warehouses", warehouseOptions);
            this.setState({warehouseOptions});
          },
          (err) => {
            if (err.data) {
              alert(err.data);
            } else {
              alert("Server issue detected, please contact admin.");
            }
          }
        );
      }
  }

  componentDidUpdate() {
    // reset('productForm');
  }

  componentWillUnmount() {
    if (this.props.currentProductDetail) {
      this.setState({Product_id: this.props.currentProductDetail.Product_id},
        () => { this.props.setCurrentProduct(this.props.currentProductDetail.Product_id); }
      );
    // this.props.clearSmallProdStatus();
    }
    // this.props.resetZone();
    this.props.resetBins();
  }

  componentWillReceiveProps(nextProps) {
    // error messages
    if (nextProps.createError && !this.props.createError) {
      let msg = "Error: ";
      if (JSON.stringify(nextProps.createError).length > 250) {
        msg += JSON.stringify(nextProps.createError).substring(0, 250);
      } else {
        msg += JSON.stringify(nextProps.createError);
      }
      alert(msg);
    }

    if (nextProps.editError && !this.props.editError) {
      let msg = "Error: ";
      // if (JSON.stringify(nextProps.editError).length > 250) {
      //   msg += JSON.stringify(nextProps.editError).substring(0, 250);
      // } else {
        msg += JSON.stringify(nextProps.editError);
      // }
      alert(msg);
    }

    if (nextProps.continueOrDiscontinueProductError && !this.props.continueOrDiscontinueProductError) {
      alert(JSON.stringify(nextProps.continueOrDiscontinueProductError));
    }

    if (nextProps.continueOrDiscontinueProductSuccess && !this.props.continueOrDiscontinueProductSuccess) {
      this.props.fetchProductDetail(nextProps.currentProductDetail.Product_id)
    }
    if ((this.props.currentProductDetail && this.props.currentProductDetail.Product_id) === (nextProps.currentProductDetail && nextProps.currentProductDetail.Product_id)) {

      if (nextProps.ConvertType && nextProps.ConvertType !== this.props.ConvertType) {
        let convertNum = null;
        if (nextProps.ConvertType === 'weight') {
          convertNum = nextProps.NetWeight;
        } else if (nextProps.ConvertType === 'unit') {
          convertNum = nextProps.PackageSize_1;
        }
        this.props.setValue('productForm', 'ConvertNum', convertNum);
      }
      if (!isHF){
        if (nextProps.PackageSize_1 !== this.props.PackageSize_1) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
          let packageSize = `${nextProps.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || this.props.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
  
          this.props.setValue('productForm', 'PackageSize', packageSize);
          if (nextProps.ConvertType === 'unit') {
            this.props.setValue('productForm', 'ConvertNum', nextProps.PackageSize_1);
          }
        }
  
        if (nextProps.NetWeight !== this.props.NetWeight) {
          if (nextProps.ConvertType === 'weight') {
            this.props.setValue('productForm', 'ConvertNum', nextProps.NetWeight);
          }
        }
  
        if (nextProps.PackageType_2 !== this.props.PackageType_2) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
  
          let packageSize = `${nextProps.PackageSize_1 || this.props.PackageSize_1 || ''}${packageType_2}*${(nextProps.PackageSize_2 && (nextProps.PackageSize_2.value || nextProps.PackageSize_2)) || this.props.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
          this.props.setValue('productForm', 'PackageSize', packageSize)
        }
  
        if (nextProps.PackageSize_2 !== this.props.PackageSize_2) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
          let packageSize = `${nextProps.PackageSize_1 || this.props.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
  
          this.props.setValue('productForm', 'PackageSize', packageSize);
        }
  
        if (nextProps.MeasureUnit_2 !== this.props.MeasureUnit_2) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
          let packageSize = `${nextProps.PackageSize_1 || this.props.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || this.props.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
  
          this.props.setValue('productForm', 'PackageSize', packageSize);
        }
      }
      

      // Used to have these for Zone-Bin-Level functionality until recently. Leaving them here in case something goes wrong and we have revert to original.
      // if (nextProps.Zone && nextProps.Zone !== this.props.Zone && this.props.Zone !== undefined) {
      //   console.log("old ZOne UNDEFINED:", this.props.Zone)
      //   console.log("new zone UNDEFINED:", nextProps.Zone)
      //   this.props.setValue('productForm', 'Bin', null);
      //   this.props.setValue('productForm', 'Level', null);
      //   this.props.zones.map( zone => {
      //     if (zone.zone_num === nextProps.Zone) {
      //       this.props.getBinsByZone(zone.id, 1);
      //     }
      //   });
      //   this.props.setValue('productForm', 'Zone', nextProps.Zone.label);
      // }
      // if (nextProps.Zone2 && nextProps.Zone2 !== this.props.Zone2 && this.props.Zone2 !== undefined) {
      //   console.log("old ZOne2:", this.props.Zone)
      //   console.log("new zone2:", nextProps.Zone)
      //   this.props.setValue('productForm', 'Bin2', null);
      //   this.props.setValue('productForm', 'Level2', null);
      //   this.props.zones.map( zone => {
      //     if (zone.zone_num === nextProps.Zone2) {
      //       this.props.getBinsByZone(zone.id, 2);
      //     }
      //   });
      //   this.props.setValue('productForm', 'Zone2', nextProps.Zone2.label);
      // }
      // if (nextProps.Zone3 && nextProps.Zone3 !== this.props.Zone3 && this.props.Zone3 !== undefined) {
      //   console.log("old ZOne3:", this.props.Zone)
      //   console.log("new zone3:", nextProps.Zone)
      //   this.props.setValue('productForm', 'Bin3', null);
      //   this.props.setValue('productForm', 'Level3', null);
      //   this.props.zones.map( zone => {
      //     if (zone.zone_num === nextProps.Zone3) {
      //       this.props.getBinsByZone(zone.id, 3);
      //     }
      //   });
      //   this.props.setValue('productForm', 'Zone3', nextProps.Zone3.label);
      // }

      if (nextProps.Zone && nextProps.Zone !== this.props.Zone && typeof nextProps.Zone === 'object') {
        this.props.setValue('productForm', 'Bin', null);
        this.props.setValue('productForm', 'Level', null);
        this.props.zones.map(zone => {
          if (zone.zone_num === nextProps.Zone.label) {
            this.props.getBinsByZone(zone.id, 1);
          }
        });
        this.props.setValue('productForm', 'Zone', nextProps.Zone.label);
      }
      if (nextProps.Zone2 && nextProps.Zone2 !== this.props.Zone2 && typeof nextProps.Zone2 === 'object') {
        this.props.setValue('productForm', 'Bin2', null);
        this.props.setValue('productForm', 'Level2', null);
        this.props.zones.map(zone => {
          if (zone.zone_num === nextProps.Zone2.label) {
            this.props.getBinsByZone(zone.id, 2);
          }
        });
        this.props.setValue('productForm', 'Zone2', nextProps.Zone2.label);
      }
      if (nextProps.Zone3 && nextProps.Zone3 !== this.props.Zone3 && typeof nextProps.Zone3 === 'object') {
        this.props.setValue('productForm', 'Bin3', null);
        this.props.setValue('productForm', 'Level3', null);
        this.props.zones.map(zone => {
          if (zone.zone_num === nextProps.Zone3.label) {
            this.props.getBinsByZone(zone.id, 3);
          }
        });
        this.props.setValue('productForm', 'Zone3', nextProps.Zone3.label);
      }
      // e

      // s
      if (nextProps.bins && nextProps.bins !== this.props.bins) {
        nextProps.bins.map(bin => {
          if (bin.section_num === this.props.Bin) {
            let foundBin = bin;
            this.props.setValue("productForm", "Bin", foundBin.section_num);
            this.props.getLevelsByBin(foundBin.id, 1);
          }
        });
      }
      if (nextProps.bins2 && nextProps.bins2 !== this.props.bins2) {
        nextProps.bins2.map(bin => {
          if (bin.section_num === this.props.Bin2) {
            let foundBin2 = bin;
            this.props.setValue("productForm", "Bin2", foundBin2.section_num);
            this.props.getLevelsByBin(foundBin2.id, 2);
          }
        });
      }
      if (nextProps.bins3 && nextProps.bins3 !== this.props.bins3) {
        nextProps.bins3.map(bin => {
          if (bin.section_num === this.props.Bin3) {
            let foundBin3 = bin;
            this.props.setValue("productForm", "Bin3", foundBin3.section_num);
            this.props.getLevelsByBin(foundBin3.id, 3);
          }
        });
      }
      // e

      // s
      if (nextProps.levels && nextProps.levels !== this.props.levels) {
        nextProps.levels.map(level => {
          if (level.bin_num === this.props.Level) {
            this.props.setValue("productForm", "Level", level.bin_num);
          }
        });
      }
      if (nextProps.levels2 && nextProps.levels2 !== this.props.levels2) {
        nextProps.levels2.map(level => {
          if (level.bin_num === this.props.Level2) {
            this.props.setValue("productForm", "Level2", level.bin_num);
          }
        });
      }
      if (nextProps.levels3 && nextProps.levels3 !== this.props.levels3) {
        nextProps.levels3.map(level => {
          if (level.bin_num === this.props.Level3) {
            this.props.setValue("productForm", "Level3", level.bin_num);
          }
        });
      }
      // e

      // s
      if (nextProps.Bin && nextProps.Bin !== this.props.Bin) {
        this.props.bins.map(bin => {
          if (bin.section_num === nextProps.Bin) {
            this.props.getLevelsByBin(bin.id, 1);
          }
        });
        this.props.setValue('productForm', 'Bin', nextProps.Bin.label);
      }
      if (nextProps.Bin2 && nextProps.Bin2 !== this.props.Bin2) {
        this.props.bins2.map(bin => {
          if (bin.section_num === nextProps.Bin2) {
            this.props.getLevelsByBin(bin.id, 2);
          }
        });
        this.props.setValue('productForm', 'Bin2', nextProps.Bin2.label);
      }
      if (nextProps.Bin3 && nextProps.Bin3 !== this.props.Bin3) {
        this.props.bins3.map(bin => {
          if (bin.section_num === nextProps.Bin3) {
            this.props.getLevelsByBin(bin.id, 3);
          }
        });
        this.props.setValue('productForm', 'Bin3', nextProps.Bin3.label);
      }
      // e

      // s
      if (nextProps.Level && nextProps.Level !== this.props.Level) {
        this.props.setValue('productForm', 'Level', nextProps.Level.label);
      }
      if (nextProps.Level2 && nextProps.Level2 !== this.props.Level2) {
        this.props.setValue('productForm', 'Level2', nextProps.Level2.label);
      }
      if (nextProps.Level3 && nextProps.Level3 !== this.props.Level3) {
        this.props.setValue('productForm', 'Level3', nextProps.Level3.label);
      }
      // e

      if (nextProps.RefPriceValue && nextProps.RefPriceValue !== this.props.RefPriceValue) {
        if(!isEcity) {
          // console.log('nextProps.RefPriceValue, this.props.RefPriceValue)', nextProps.RefPriceValue, this.props.RefPriceValue);
          // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // this.setState({
          //   priceLv1,
          //   priceLv2,
          //   priceLv3,
          //   priceLv4,
          //   priceLv5,
          // });
        }
      }
    }

    if (nextProps.convertableProductsFetched && nextProps.convertableProductsFetched !== this.props.convertableProductsFetched && nextProps.convertableProductsFetched.relations.length > 0) {
      const { relations } = nextProps.convertableProductsFetched;
      this.setState({ relatedProducts: relations.map(product => ({...product, ConvertNum: product.ConvertNum || product.convert_number || null})) })
      this.props.setValue('productForm', 'Related_Products', relations);
    }
    if (nextProps.ProductNum && nextProps.ProductNum !== this.props.ProductNum) {
      this.props.fetchConvertableProducts(nextProps.ProductNum);
    }
    if (nextProps.currentProductDetail && nextProps.currentProductDetail !== this.props.currentProductDetail) {
      this.props.zones.map(zone => {
        if (zone.zone_num === nextProps.currentProductDetail.Zone) {
          let foundZone = zone;
          this.props.setValue("productForm", "Zone", foundZone.zone_num);
          this.props.getBinsByZone(foundZone.id, 1);
        }
        if (zone.zone_num === this.props.Zone2) {
          let foundZone2 = zone;
          this.props.setValue("productForm", "Zone2", foundZone2.zone_num);
          this.props.getBinsByZone(foundZone2.id, 2);
        }
        if (zone.zone_num === this.props.Zone3) {
          let foundZone3 = zone;
          this.props.setValue("productForm", "Zone3", foundZone3.zone_num);
          this.props.getBinsByZone(foundZone3.id, 3);
        }
      });
      const productNavigation_1 = {
        ProductCategory1_id: nextProps.currentProductDetail.ProductCategory1_id,
        ProductGroup_id: nextProps.currentProductDetail.ProductGroup_id,
        ProductNum: nextProps.currentProductDetail.ProductNum,
        RefNum: nextProps.currentProductDetail.RefNum,
        suggestedProdNum: nextProps.currentProductDetail.ProductNum.substring(4, 7),
        isLinked: false,
        Name: nextProps.currentProductDetail.Name,
        Description: nextProps.currentProductDetail.Description,
        IsLarge: nextProps.currentProductDetail.IsLarge,
        LastDigit: nextProps.currentProductDetail.ProductNum.substring(7, 8),
        isMadePrev: true,
      };
      const {
        P1Percentage: p1Percentage,
        P2Percentage: p2Percentage,
        P3Percentage: p3Percentage,
        P4Percentage: p4Percentage,
        P5Percentage: p5Percentage,
        PriceLv1,
        PriceLv2,
        PriceLv3,
        PriceLv4,
        PriceLv5,
      } = nextProps.currentProductDetail;
      // console.log('nextProps.currentProductDetail', nextProps.currentProductDetail);
      // const priceLv1 = isEcity ? PriceLv1 : calculatePriceLevelNormal(p1Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv2 = isEcity ? PriceLv2 : calculatePriceLevelNormal(p2Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv3 = isEcity ? PriceLv3 : calculatePriceLevelNormal(p3Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv4 = calculatePriceLevelNormal(p4Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv5 = calculatePriceLevelNormal(p5Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      const priceLv1 = PriceLv1;
      const priceLv2 = PriceLv2;
      const priceLv3 = PriceLv3;
      const priceLv4 = PriceLv4;
      const priceLv5 = PriceLv5;
      this.setState({
        p1Percentage: isEcity ? calculatePricePercentage(PriceLv1, null, nextProps.ArrivalPrice) : p1Percentage,
        p2Percentage: isEcity ? calculatePricePercentage(PriceLv2, null, nextProps.ArrivalPrice) : p2Percentage,
        p3Percentage: isEcity ? calculatePricePercentage(PriceLv3, null, nextProps.ArrivalPrice) : p3Percentage,
        p4Percentage,
        p5Percentage,
        priceLv1,
        priceLv2,
        priceLv3,
        priceLv4,
        priceLv5,
        Product_id: nextProps.currentProductDetail.Product_id,
        productNavigation_1,
        selectedProduct: {
          currentPackageSize: nextProps.currentProductDetail.PackageSize,
          currentProdId: nextProps.currentProductDetail.Product_id,
          currentProdName: nextProps.currentProductDetail.Name,
          currentProdNum: nextProps.currentProductDetail.ProductNum,
          currentRefNum: nextProps.currentProductDetail.RefNum,
          currentProductCRV: nextProps.currentProductDetail.CRV,
          currentProductDescription: nextProps.currentProductDetail.Description,
          currentProductWeight: nextProps.currentProductDetail.NetWeight,
          currentRefNum: nextProps.currentProductDetail.RefNum,
          currentRefPrice: nextProps.currentProductDetail.RefPrice,
          netWeight: nextProps.currentProductDetail.NetWeight,
        },
        ProductSKU: nextProps.currentProductDetail.ProductSKU,
        MixedProduct: nextProps.currentProductDetail.MixedProducts,
        permissionChecked: false,
      });
      if (!nextProps.currentProductDetail.PriceType) {
        switch (nextProps.currentProductDetail.ProductType) {
          case 'Fixed':
            this.props.setValue('productForm', 'PriceType', 'unit')
            break;
          default:
            this.props.setValue('productForm', 'PriceType', 'weight')
        }
      }
      if (nextProps.currentProductDetail.MixedProducts) { //temporary fix for backend
        if (nextProps.currentProductDetail.MixedProducts.length > 0) {
          const mixedProductBaseUnit = {
            value: nextProps.currentProductDetail.MixedProducts[0].Unit,
            label: nextProps.currentProductDetail.MixedProducts[0].Unit,
          }
          this.setState({
            MixedProductBaseUnit: mixedProductBaseUnit,
          });
          this.props.setValue('productForm', 'MixedProductBaseUnit', nextProps.currentProductDetail.MixedProducts[0].Unit);
          this.props.setValue('productForm', 'MixedProduct', nextProps.currentProductDetail.MixedProducts);
        }
      }
      if (nextProps.currentProductDetail.Product_id) {
        this.getDisplayCategories(nextProps.currentProductDetail.Product_id);
      }
    }

    if (nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id !== this.props.Default_Warehouse_id) {
      if (nextProps.Default_Warehouse_id.value) {
        console.log("Default_Warehouse_id", nextProps.Default_Warehouse_id.value);
        this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
        this.props.setValue('productForm', 'Zone', null);
        this.props.setValue('productForm', 'Bin', null);
        this.props.setValue('productForm', 'Level', null);
      }
    }
    if (nextProps.dirty != this.props.dirty) {
      this.setState({
        dirty: nextProps.dirty
      });
    }
    if (nextProps.ProductGroup_id && nextProps.ProductGroup_id !== this.props.ProductGroup_id) {
      this.props.fetchGroupCategories(nextProps.ProductGroup_id.value || nextProps.ProductGroup_id);
    }
    if (nextProps.initialValues && nextProps.initialValues !== this.props.initialValues) {
      this.props.setValue('productForm', 'GeneralNumber', nextProps.initialValues.GeneralNum);
      this.props.setValue('productForm', 'ProductNumber', nextProps.initialValues.ProductNum);
    }

    // if(!nextProps.currentProduct && nextProps.currentProduct != this.props.currentProduct) {
    //   this.forceUpdate();
    // }

    if (nextProps.smallProductDetail && nextProps.smallProductDetail !== this.props.smallProductDetail) {
      this.props.setValue('productForm', 'SmallNetWeight', nextProps.smallProductDetail.NetWeight);
      // this.props.setValue('productForm', 'SmallFixedWeight', nextProps.smallProductDetail);
      // this.props.setValue('productForm', 'SmallCatchWeight', nextProps.smallProductDetail);
    }

    if (nextProps.productSaved && nextProps.productSaved !== this.props.productSaved) {
      this.setState({
        priceLv1: null,
      }, () => {
        this.openShowProductCreated();
      })
    }

    // if (nextProps.promotionDetails && nextProps.promotionDetails !== this.props.promotionDetails) {
    //   let detailRows = (nextProps.promotionDetails) ? [...nextProps.promotionDetails.Promotion_Line] : [];
    //   let promotionDetails = {...this.state.promotionDetails, rows: detailRows};
    //   this.setState({promotionDetails})
    // }
    if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
      if (nextProps.checkPermissionSuccess.manager) {
        this.closeEditRecPermission();
        this.openProductGroupEdit();
      }
    }

    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      if (this.state.deleteModalOpen === true) {
        this.closeDeleteModal();
        this.props.deleteProduct(this.props.currentProductDetail.Product_id);
      } else {
        this.closeCheckAuthorize();
        this.openProductGroupEdit();
      }
    }

    if (this.props.currentProductDetail && !nextProps.Default_Warehouse_id) {
      this.props.fetchWarehouseDetail(this.props.currentProductDetail.Default_Warehouse_id);
      this.setState({ PackageTypeC: this.props.currentProductDetail.PackageType });
    }

    if(nextProps.ProductCost !== this.props.ProductCost) {
      // let arrivalPrice = Number(nextProps.ProductCost) + ( nextProps.currentProductDetail ? Number(nextProps.currentProductDetail.ShippingFeeUnitPrice) + Number(nextProps.currentProductDetail.MiscUnitPrice) : 0 );
      if(isEcity && !this.state.priceLv1 && nextProps.currentProductDetail) {

        // const p1Percentage = calculatePricePercentage(this.priceLv1.PriceLv1, this.props.RefPriceValue, basePrice)
        // const p2Percentage = calculatePricePercentage(this.priceLv1.PriceLv2, this.props.RefPriceValue, basePrice)
        // const p3Percentage = calculatePricePercentage(this.priceLv1.PriceLv3, this.props.RefPriceValue, basePrice)
        // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, arrivalPrice);
        const priceLv1 = nextProps.currentProductDetail.PriceLv1;
        const priceLv2 = nextProps.currentProductDetail.PriceLv2;
        const priceLv3 = nextProps.currentProductDetail.PriceLv3;
        // const priceLv4 = nextProps.currentProduct.PriceLv4;
        // const priceLv5 = nextProps.currentProduct.PriceLv5;
        this.setState({
          priceLv1,
          priceLv2,
          priceLv3,
          // priceLv4,
          // priceLv5,
        });
      }
    }
    if (nextProps.ArrivalPrice !== this.props.ArrivalPrice && this.state.priceLv1 && isEcity) {
      const p1Percentage = calculatePricePercentage(this.state.priceLv1, this.props.RefPriceValue, nextProps.ArrivalPrice)
      const p2Percentage = calculatePricePercentage(this.state.priceLv2, this.props.RefPriceValue, nextProps.ArrivalPrice)
      const p3Percentage = calculatePricePercentage(this.state.priceLv3, this.props.RefPriceValue, nextProps.ArrivalPrice)
      this.setState({
        p1Percentage,
        p2Percentage,
        p3Percentage,
      })
    }

    if(nextProps.confirmPasscodeModal.verified) {
      this.setState({
        permissionChecked: true,
      }, () => {
        this.props.setPasscodeVerificationStatus(false);
      })
    }

    if (nextProps.currentProductDetail) {
      const meta_info = {
        meta_title: nextProps.currentProductDetail.meta_title,
        meta_keywords: nextProps.currentProductDetail.meta_keywords,
        meta_description: nextProps.currentProductDetail.meta_description,
      };
      this.setState({ meta_info });
      
      if (nextProps.currentProductDetail.IsSyncToESL) {
        this.setState({ eslEnabled: true });
      } else {
        this.setState({ eslEnabled: false });
      }
    }

    if (nextProps.CalcoDispatchCase) {
      this.props.setValue('productForm', 'SmallNetWeight', nextProps.CalcoDispatchCase);
    }
    if (nextProps.CalcoDispatchBag) {
      this.props.setValue('productForm', 'SmallNetWeight', nextProps.CalcoDispatchBa);
    }

    if (nextProps && (nextProps.IsAllTaxable === true || nextProps.IsAllTaxable === 'true')) {
      this.props.setDefaultOfForm("IsTaxable", "true", "productForm");
    }
    // if (!nextProps.DimensionUnit) {
    //   this.props.setValue('productForm', 'DimensionUnit', 'inch');
    // }
  }

  ESLCheckbox = props => {
    return (
      <input
        {...props.input}
        type="checkbox"
        value={!props.input.value ? "true" : "false"}
        checked={props.input.value === true || props.input.value === "true"}
        disabled={props.disabled}
        onClick={(e)=>this.handleESLCheckbox(e)}
      />
    );
  }

  handleESLCheckbox(e) {
    let productId = this.props.currentProductDetail.Product_id;
    if (e.target.value === 'true' || e.target.value === true) {
      this.props.initializeESL(productId)
        .then((response) => {
          this.setState({ eslEnabled: true });
        }, (err) => {
          alert("ESL Error: " + err.data);
          this.props.setValue('productForm', 'IsSyncToESL', 'false')
        });
    }
    if (e.target.value === 'false' || e.target.value === false) {
      this.props.deleteESL(productId)
        .then((response) => {
          this.setState({ eslEnabled: false });
        }, (err) => {
          alert("ESL Error: " + err.data);
          this.props.setValue('productForm', 'IsSyncToESL', 'true')
        });
    }
  } 

  //Get Display Categories
  getDisplayCategories = (id) => {
    this.props.fetchDisplayCategories(id).then(() => {
      if (this.props.display_categories) {
        // this.state.displayCategories = this.props.display_categories;
        this.setState({displayCategories: this.props.display_categories});
      }
    });
  }

  //Mix Product Search
  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  // Helper function of popups
  closeDeleteModal() { this.setState({ deleteModalOpen: false }); }
  openDeleteModal() {
    this.setState({ deleteModalOpen: true });
    this.props.clearCheckPassword();
  }
  openVendor() { this.setState({ vendorOpen: true }); }
  closeVendor() { this.setState({ vendorOpen: false }); }
  openGroup() { this.setState({ groupOpen: true }); }
  closeGroup() { this.setState({ groupOpen: false }); }
  openCategory() { this.setState({ categoryOpen: true }); }
  closeCategory() { this.setState({ categoryOpen: false }); }
  openShowProductCreated() { this.setState({ showProductCreatedOpen: true }); }
  closeShowProductCreated() { this.setState({ showProductCreatedOpen: false }); }
  closeNavigation() { this.setState({ productNavigationOpen: []}); }
  openPackageType() { this.setState({ packageTypeOpen: true }); }
  closePackageType() { this.setState({ packageTypeOpen: false }); }

  updateSKU = (newSkus) => {
    this.setState({
      ProductSKU: newSkus,
    });
    this.closeSkusModal();
  }

  openMobileDescBox = () => {
    this.setState({ mobileDescBoxOpen: true });
  }

  openDisplayCategoryBox = () => {
    this.setState({ displayCategoryBoxOpen: true });
  }

  openSkusModal = () => {
    this.setState({ skusModal: true });
  }

  closeSkusModal = () => {
    this.setState({ skusModal: false });
  }

  closeMobileDescBox = () => {
    this.setState({ mobileDescBoxOpen: false });
  }

  closeDisplayCategoryBox = () => {
    this.setState({ displayCategoryBoxOpen: false });
  }

  openAddConvertProducts = () => {
    this.setState({ addConvertProductsOpen: true });
  }

  closeAddConvertProducts = () => {
    this.setState({ addConvertProductsOpen: false });
  }

  openImageModal = () => {
    this.setState({ imagesModalOpen: true });
  }

  closeImageModal = () => {
    this.setState({ imagesModalOpen: false });
  }

  openProductGroupEdit = () => {
    this.setState({ editProductGroup: true });
  }
  closeProductGroupEdit = () => {
    this.setState({ editProductGroup: false });
  }

  openESLModal = () => {
    this.setState({ eslModalVisibility: true });
  }

  closeESLModal = () => {
    this.setState({ eslModalVisibility: false });
  }

  openEditRecPermission = (editGroupFormAction = 'changeGroup'/* for moving products to other groups */) => {
    this.setState({
      case: 'editRecPermission',
      editRecPermissionOpen: true,
      editGroupFormAction,
    });
  }

  checkAuthorize = (password) => {
    this.props.checkPassword(password);
  }

  openCheckAuthorize = (editGroupFormAction) => {
    this.props.clearCheckPassword();
    this.setState({
      checkAuthorizeOpen: true,
      editGroupFormAction,
    });
  }

  closeCheckAuthorize = () => {
    this.setState({
      checkAuthorizeOpen: false
    });
  }

  closeEditRecPermission = () => {
    this.setState({ editRecPermissionOpen: false });
  }

  selectPackageType(row) {
    this.props.setValue("productForm", 'PackageType_2', row.Simple);
    this.closePackageType();
  }

  handleFetchPromotionDetails = (productId) => {
    const handleSuccess = (response) => {
      const promotionDetails = { ...this.state.promotionDetails, rows: response.data.promotions };
      this.setState({
        promotionDetailsIsLoading: false,
        promotionDetails,
      });
    }

    const handleFailure = (error) => {
      this.setState({ promotionDetailsIsLoading: false }, () => {
        alert(JSON.stringify(error));
      });
    }

    this.setState({ promotionDetailsIsLoading: true }, () => {
      fetchPromoDetailsByProduct(productId, handleSuccess, handleFailure);
    });
  }

  handleMobileDescBoxClick = () => {
    const handleSuccess = (response) => {
      this.setState({
        isLoadingMobileDescBoxText: false,
        mobileDescriptionHTML: response.data.rich_text_description,
      }, () => {
        this.openMobileDescBox();
      });
    };
    const handleFailure = (err) => {
      this.setState({ isLoadingMobileDescBoxText: false }, () => {
        alert(JSON.stringify(err));
      });
    };
    this.setState({ isLoadingMobileDescBoxText: true }, () => {
      fetchMobileDescriptionBoxText(this.props.currentProductDetail.Product_id, handleSuccess, handleFailure);
    });
  }

  handleDisplayCategoryBoxClick = () => {
    this.openDisplayCategoryBox();
  }

  handleSkusClick = () => {
    this.openSkusModal();
  }

    handleClickFinish(productNavigation_3) {
      let packageSize = `${this.state.productNavigation_2.PackageSize_1 || ""}
      ${(this.state.productNavigation_2.PackageType_2 && this.state.productNavigation_2.PackageType_2.value) || ""}
      *${this.state.productNavigation_2.PackageSize_2 || ""}
      ${(this.state.productNavigation_2.MeasureUnit_2 && this.state.productNavigation_2.MeasureUnit_2.value) || ""}`;
      if(packageSize[0] == '*') {
        packageSize = packageSize.slice(1);
      }
      let netWeightUnit = this.state.productNavigation_2.NetWeight_2 && this.state.productNavigation_2.NetWeight_2.value;
      let netWeight = parseFloat(this.state.productNavigation_2.NetWeight_1) || 0;
      if(netWeightUnit == "kg") {
        netWeight = 2.20462 * netWeight;
      }
      let diffWeight = 0;
      if(this.state.productNavigation_2.ProdType && this.state.productNavigation_2.ProdType.value == "Non-Fixed") {
        if(netWeight > 10) {
          diffWeight = 10;
        }
        else if(netWeight > 0) {
          diffWeight = 5;
        }
      }

      let convertNum = null;
      if(productNavigation_3.ConvertType === "weight") {
        convertNum = netWeight
      }
      else if (productNavigation_3.ConvertType === "unit") {
        convertNum = this.state.productNavigation_2.PackageSize_1
      }

      this.props.setValue('productForm', 'ProductGroup_id', this.state.productNavigation_1.ProductGroup_id)
      this.props.setValue('productForm', 'ProductCategory1_id', this.state.productNavigation_1.ProductCategory1_id)
      this.props.setValue('productForm', 'Name', this.state.productNavigation_1.Name)
      if (isWIZ) {
        this.props.setValue('productForm', 'RefNum', this.state.productNavigation_1.Name)
      }
      this.props.setValue('productForm', 'Description', this.state.productNavigation_1.Description)
      this.props.setValue('productForm', 'ProductNum', this.state.productNavigation_1.ProductNum)
      this.props.setValue('productForm', 'IsRelated', this.state.productNavigation_1.isLinked.toString())
      this.props.setValue('productForm', 'IsLarge', this.state.productNavigation_1.IsLarge)

      this.props.setValue('productForm', 'ProductType', this.state.productNavigation_2.ProdType)
      this.props.setValue('productForm', 'PackageType', this.state.productNavigation_2.PackageType)
      this.props.setValue('productForm', 'PackageSize', packageSize)
      this.props.setValue('productForm', 'PackageSize_1', this.state.productNavigation_2.PackageSize_1)
      this.props.setValue('productForm', 'PackageType_2', this.state.productNavigation_2.PackageType_2)
      this.props.setValue('productForm', 'PackageSize_2', this.state.productNavigation_2.PackageSize_2)
      this.props.setValue('productForm', 'MeasureUnit_2', this.state.productNavigation_2.MeasureUnit_2)
      this.props.setValue('productForm', 'MeasureUnit', this.state.productNavigation_2.NetWeight_2);
      this.props.setValue('productForm', 'NetWeight', netWeight);
      this.props.setValue('productForm', 'ShippingWeight', netWeight);

      this.props.setValue('productForm', 'MinWeightRange', Math.max(0, netWeight-diffWeight));
      this.props.setValue('productForm', 'MaxWeightRange', netWeight+diffWeight);
      this.props.setValue('productForm', 'RefPrice', this.state.productNavigation_2.RefPrice)
      this.props.setValue('productForm', 'LowestSalePrice', this.state.productNavigation_2.LowestSalePrice)

      this.props.setValue('productForm', 'ConvertNum', convertNum)
      this.props.setValue('productForm', 'SmallProdType', productNavigation_3.SmallProdType)
      this.props.setValue('productForm', 'SmallPackageType', productNavigation_3.SmallPackageType)
      this.props.setValue('productForm', 'ConvertType', productNavigation_3.ConvertType)
      // break points
      const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);

      this.setState({
        priceLv1,
        priceLv2,
        priceLv3,
        priceLv4,
        priceLv5,
      })
    }

    handleOnFocus(event) {
      event.target.select();
    }

    onDrop(files) {
      // this.props.attachProductImage(this.props.currentProduct.Product_id, files);
      this.setState({
          files: files
      });
    }

    onOpenClick() {
      this.props.clearAttachedProductImage();
      // this.refs.dropzone.open();
    }

    title() {
      if (!this.props.params.id) {
        return <h3><Translate value="create_a_new_product"/></h3>
      }
      return <h3><Translate value="edit_product"/>{this.props.currentProduct.Name}</h3>
    }

    navigate(page) {
      let productNavigationOpen = [...this.state.productNavigationOpen];
      productNavigationOpen = productNavigationOpen.map(r => {
        return false
      })
      productNavigationOpen[page] = true;
      this.setState({productNavigationOpen});
    }

    saveCurrentModal(ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum) {
      let productNavigation_1 = {...this.state.productNavigation_1, ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum}
      this.setState({productNavigation_1})
    }

    handleClickNext_1(ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum) {
      this.saveCurrentModal(ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum);
      this.navigate(1);
    }

    handleClickPrev_2(
      ProdType,
      PackageType,
      PackageSize_1,
      PackageType_2,
      PackageSize_2,
      MeasureUnit_2,
      NetWeight_1,
      NetWeight_2,
      RefPrice,
      LowestSalePrice,
    ) {
      let productNavigation_2 = {
        ...this.state.productNavigation_2,
        ProdType,
        PackageType,
        PackageSize_1,
        PackageType_2,
        PackageSize_2,
        MeasureUnit_2,
        NetWeight_1,
        NetWeight_2,
        RefPrice,
        LowestSalePrice,
      }
      this.setState({ productNavigation_2 })
      this.navigate(0);
    }

    handleClickNext_2(
      ProdType,
      PackageType,
      PackageSize_1,
      PackageType_2,
      PackageSize_2,
      MeasureUnit_2,
      NetWeight_1,
      NetWeight_2,
      RefPrice,
      LowestSalePrice,
    ) {
      let productNavigation_2 = {
        ...this.state.productNavigation_2,
        ProdType,
        PackageType,
        PackageSize_1,
        PackageType_2,
        PackageSize_2,
        MeasureUnit_2,
        NetWeight_1,
        NetWeight_2,
        RefPrice,
        LowestSalePrice,
      }
      // this.setState({ productNavigation_2 });
      this.setState({ productNavigation_2 }, () => {
        if (!isHMM) {
          this.navigate(2);
        } else {
          this.saveProductFormNavigation_3(1, null, null, "unit");
          this.closeNavigation();
        }
      });
    }

    handleClickPrev_3(
      ConvertNum,
      SmallProdType,
      SmallPackageType,
      ConvertType,
    ) {
      this.saveProductFormNavigation_3(
        ConvertNum,
        SmallProdType,
        SmallPackageType,
        ConvertType,
      )
      this.navigate(1);
    }

    saveProductFormNavigation_3(
      ConvertNum,
      SmallProdType,
      SmallPackageType,
      ConvertType,
    ) {
      let productNavigation_3 = {
        ...this.state.productNavigation_3,
        ConvertNum,
        SmallProdType,
        SmallPackageType,
        ConvertType,
      }
      this.setState({ productNavigation_3 })
      this.handleClickFinish(productNavigation_3);
    }

    saveRichText(htmlText) {
      const { Product_id } = this.props.currentProductDetail;
      this.props.saveMobileDescriptionBoxText(Product_id, htmlText);
    }

    handleKeyPress(value, event){
      if (event.charCode == 13){
        event.preventDefault()
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    handleAutoConvertClick = (product) => {
      const relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      lodashMap(relatedProducts, (relatedProduct) => {
        relatedProduct.auto_convert = false;
      });
      relatedProducts[product.index].auto_convert = !this.state.relatedProducts[product.index].auto_convert;
      this.setState({ relatedProducts });
    }

    handleConvertInput = (product, e) => {
      const relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      relatedProducts[product.index].ConvertNum = e;
      this.setState({ relatedProducts });
    }

    handleRelatedProductDelete = (productToRemove) => {
      let relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      relatedProducts = lodashFilter(relatedProducts, product => product.index !== productToRemove.index);
      lodashMap(relatedProducts, (product, index) => {
        product.index = index;
      });
      this.setState({ relatedProducts });
    }

    handleAddConvertProductClick = () => {
      const handleSuccess = (response) => {
        this.setState({
          isLoadingCategoryProducts: false,
          categoryProducts: response.data,
        }, this.openAddConvertProducts);
      };

      const handleFailure = (error) => {
        this.setState({ isLoadingCategoryProducts: false });
        alert(JSON.stringify(error));
      };

      const { currentProductDetail } = this.props;
      const { productNavigation_1 } = this.state;
      if ((currentProductDetail && currentProductDetail.ProductCategory1_id)
        || (productNavigation_1 && productNavigation_1.ProductCategory1_id.value)
      ) {
        this.setState({ isLoadingCategoryProducts: true }, () => {
          const productCategoryId = (currentProductDetail) ? currentProductDetail.ProductCategory1_id : productNavigation_1.ProductCategory1_id.value
          this.props.fetchProductsByCategory(productCategoryId, handleSuccess, handleFailure, true);
        });
      }
    }

    modifyConvertableProductList = (product) => {
      let relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      const existingProduct = lodashFind(this.state.relatedProducts, relatedProduct => relatedProduct.ProductNum === product.ProductNum);
      if (existingProduct) {
        relatedProducts = lodashFilter(relatedProducts, relatedProduct => relatedProduct.ProductNum !== existingProduct.ProductNum);
      } else {
        const newProduct = (isATL || isCS || isAmzey || isAPO || isUSPride) ? {
          PackageSize: product.PackageSize,
          ProductType: product.ProductType,
          ProductNum: product.ProductNum,
          RefNum: product.RefNum,
          Product_id: product.Product_id,
          auto_convert: false,
          ConvertNum: 1,
          index: relatedProducts.length,
        } : {
          PackageSize: product.PackageSize,
          ProductType: product.ProductType,
          ProductNum: product.ProductNum,
          Product_id: product.Product_id,
          auto_convert: false,
          index: relatedProducts.length,
        };
        relatedProducts.push(newProduct);
      }
      this.setState({ relatedProducts });
    }

    // Mix Products Render
    renderMixedProduct() {
      const packageTypeOptions = this.getPackageTypeOptions();
      return (
        <FieldArray name="MixedProduct" component={renderMixProductArrays} suggestProduct={this.state.suggestProduct} packageTypeOptions={packageTypeOptions}/>
      )
    }

    // Render the vendor, group and category options dynamically with the information
    // on the server.

    renderVendors() {
      if (this.props.vendorIsLoading) return <Spinner/> // If vendor is loading, show a spinner.
      const vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
      const vendorNumOptions = this.getVendorNumOptions();
      return (
        <FieldArray name="Vendors" component={renderVendorArrays} openVendor={this.openVendor} vendorNumOptions={vendorNumOptions} vendorNameOptions={vendorNameOptions} />
      )
    }

    renderConvertDetails() {
      if (this.state.productNavigationOpen[2] === true) {
        return <div />
      }
      const { relatedProducts, productNavigation_1, productNavigation_2 } = this.state;
      let currentProductNum;
      let currentRefNum;
      let currentPackageSize;
      let currentProductType;
      const isCreate = (!this.props.params.id);
      if (isCreate) {
        if (!productNavigation_1.ProductNum
          || !productNavigation_2.PackageSize_1
          || !productNavigation_2.PackageSize_2
          || !productNavigation_2.PackageType_2
          || !productNavigation_2.MeasureUnit_2
        ) {
          return <div />;
        }
        currentProductNum = productNavigation_1.ProductNum;
        currentRefNum = productNavigation_1.RefNum;
        currentPackageSize = `${productNavigation_2.PackageSize_1}${productNavigation_2.PackageType_2.value}*${productNavigation_2.PackageSize_2}${productNavigation_2.MeasureUnit_2.value}`;
        currentProductType = productNavigation_2.ProdType.value;
      } else if (relatedProducts.length > 0) {
        currentProductNum = relatedProducts[0].ProductNum;
        currentRefNum = relatedProducts[0].RefNum;
        currentPackageSize = relatedProducts[0].PackageSize;
        currentProductType = relatedProducts[0].ProductType;
      }
      if (this.props.fetchingConvertableProducts && !this.props.convertableProductsFetchError) {
        return <Spinner />;
      }
      return (
        (relatedProducts.length > 0) &&
          <div>
            {
              lodashMap(relatedProducts, (product, index) => (
                (index === 0)
                  ? (
                    <div key={index}>
                      <div className="related-products-heading1">
                        <div className="related-products-current">
                          <span>{ isUSPride ? currentRefNum : currentProductNum }</span>
                          <span>{ currentPackageSize }</span>
                        </div>
                        <div className="related-products-heading2">
                          <span>{ currentProductType }</span>
                          <SpinnerButton
                            className="related-products-link-product"
                            bsStyle="primary"
                            icon="fa-plus"
                            onClick={this.handleAddConvertProductClick}
                            disabled={this.state.isLoadingCategoryProducts}
                            loading={this.state.isLoadingCategoryProducts}
                          />
                        </div>
                      </div>
                      <hr style={{ borderTopColor: '#000' }} />
                    </div>
                  ) : (
                    <div key={index} className="related-products">
                      <div style={{fontSize: '12px'}}>{ isUSPride ? product.RefNum : product.ProductNum }</div>
                      <div style={{width: '80px', fontSize: '12px'}}>{ product.PackageSize }</div>
                      <div className="related-products-auto-convert">
                        {
                          (isATL || isCS || isAmzey || isAPO || isUSPride) &&
                      <input
                          type="text"
                          style={{border: '1px solid black', width: '30px', marginRight: '12px', paddingLeft: '5px'}}
                          name="link-product"
                          value={product.ConvertNum}
                          onChange={(e) => {
                            this.handleConvertInput(product, e.target.value)
                          }}
                        />
    }
                        <span>{ product.ProductType }</span>
                        <div className="auto-convert-block">
                          <input
                            type="checkbox"
                            name="link-product"
                            checked={product.auto_convert}
                            onClick={() => this.handleAutoConvertClick(product)}
                          />
                          <span><Translate value="auto" /></span>
                        </div>
                        <Button
                          className="related-products-link-product"
                          bsStyle="danger"
                          onClick={() => this.handleRelatedProductDelete(product)}
                        >
                          <em className="fa fa-trash" />
                        </Button>
                      </div>
                    </div>
                  )
              ))
            }
          </div>
      );
      // return (
      //     <FieldArray name="Related_Products" component={renderConvertDetailsList} />
      // )
    }

    renderSearchStatus() {
      if (this.props.smallProductDetailIsLoading) return <Col xs={2}><Spinner/></Col>
      else if (this.props.smallProductDetailError || (this.props.smallProductDetail && this.props.smallProductDetail.length == 0)) {
        return (
          <Col xs={2}>
            <i className="fa fa-times alert alert-danger" />
          </Col>
        )
      } else if (this.props.smallProductDetail) {
        return (
          <Col xs={2}>
            <i className="fa fa-check alert alert-success" />
          </Col>
        )
      } else {
        return;
      }
    }

    // Push vendor name and number in to 2 JSON arrays.
    getVendorNameOptions() {
      const vendorNameOptions = [];
      this.props.vendors.map(vendor => {
        vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name })
      });
      return vendorNameOptions;
    }

    getVendorNumOptions() {
      const vendorNumOptions = [];
      this.props.vendors.map(vendor => {
        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum })
      });
      return vendorNumOptions;
    }

    // promotion function
    getCustomerOptions = () => {
      const { customerList } = this.state;
      const customerOptions = [{ value: 'All', label: 'All' }];
      lodashMap(customerList, (customer) => {
        const option = { value: customer.Name, label: customer.Name };
        customerOptions.push(option);
      });
      return customerOptions;
    }

    setStartDate = (e) => {
      if (this.state.endDateSelected && e > this.state.endDateSelected) {
        alert(I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
        return;
      }
      this.setState({ startDateSelected: e });
    }

    setEndDate = (e) => {
      if (this.state.startDateSelected && e < this.state.startDateSelected) {
        alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
        return;
      }
      this.setState({ endDateSelected: e });
    }

    openDeletePromotion = (promotionToDeleteId) => {
      this.setState({ deletePromotionOpen: true, promotionToDeleteId });
    }

    closeDeletePromotion = () => {
      this.setState({ deletePromotionOpen: false });
    }

    openEditPromotion = () => {
      this.setState({ editPromotionOpen: true });
    }

    closeEditPromotion = (refresh) => {
      this.setState({ editPromotionOpen: false }, () => {
        if (refresh) {
          this.handleFetchPromotionDetails(this.state.Product_id);
        }
      });
    }

    handleSelectionChange = (value, fieldName) => {
      this.setState({ [fieldName]: value });
    }
    handleTextInputChange = (event) => {
      this.setState({ [event.target.name]: event.target.value });
    }
    handleDiscountButtonClick = (discountType) => {
      this.setState({ discountType });
    }
    handleTabSelect = (key) => {
      if (this.state.isLoadingSavePromotion) {
        return;
      }
      const rows = lodashFilter(this.state.promotions, row => row.Method === key);
      const promotionsTableData = { ...this.state.promotionsTableData, rows };
      this.setState({ tabsKey: key, promotionsTableData });
    }
    handleSavePromotion = () => {
      const handleSuccess = () => {
        this.setState({
          isLoadingSavePromotion: false,
          startDateSelected: undefined,
          endDateSelected: undefined,
          customerGroupSelected: '',
          paymentTypeSelected: '',
        }, () => {
          const state = clearForm(this.state);
          this.handleFetchPromotionDetails(this.state.Product_id);
          this.setState(state);
          this.setState({
            selectedProduct: {
              currentPackageSize: this.props.currentProductDetail.PackageSize,
              currentProdId: this.props.currentProductDetail.Product_id,
              currentProdName: this.props.currentProductDetail.Name,
              currentProdNum: this.props.currentProductDetail.ProductNum,
              currentProductCRV: this.props.currentProductDetail.CRV,
              currentProductDescription: this.props.currentProductDetail.Description,
              currentProductWeight: this.props.currentProductDetail.NetWeight,
              currentRefNum: this.props.currentProductDetail.RefNum,
              currentRefPrice: this.props.currentProductDetail.RefPrice,
              netWeight: this.props.currentProductDetail.NetWeight,
            }
          });
        });
      };
      const handleFailure = (error) => {
        this.setState({ isLoadingSavePromotion: false });
        alert(JSON.stringify(error));
      };
      let promotionLine;
      switch (this.state.tabsKey) {
        case 'ByQuantity':
          promotionLine = desiredShapeByQuantity(this.state);
          break;
        case 'BuyAGetB':
          promotionLine = desiredShapeBuyAGetB(this.state);
          break;
        case 'ByTotalPriceProduct':
          promotionLine = desiredShapeByTotalPriceProduct(this.state);
          break;
        case 'ByTotalPriceDiscount':
          promotionLine = desiredShapeByTotalPriceDiscount(this.state);
          break;
        default:
          break;
      }
      this.setState({ isLoadingSavePromotion: true }, () => {
        savePromotion(promotionLine, handleSuccess, handleFailure);
      });
    }
    handleDeletePromotion = () => {
      const handleSuccess = () => {
        this.handleFetchPromotionDetails(this.state.Product_id);
      };

      const handleFailure = (error) => {
        alert(JSON.stringify(error));
      };

      const { promotionToDeleteId } = this.state;
      deletePromotion(promotionToDeleteId, handleSuccess, handleFailure);
    }

    handleOpenEditPromotion = (promotionLineId) => {
      const handleSuccess = (response) => {
        this.setState({
          isLoadingPromoDetails: false,
          promotionToEdit: response.data,
        });
      };

      const handleFailure = (error) => {
        this.setState({ isLoadingPromoDetails: false });
        alert(JSON.stringify(error));
      };

      this.setState({ isLoadingPromoDetails: true }, () => {
        this.openEditPromotion();
        fetchPromoDetails(promotionLineId, handleSuccess, handleFailure);
      });
    }

    renderByQuantityTab = () => {
      const byQuantityTitle = (<Translate value="by_quantity" />);
      return (
        <Tab eventKey="ByQuantity" title={byQuantityTitle}>
          <div className="by-quantity-tab">
            { this.renderByQuantityPromoDetails() }
          </div>
        </Tab>
      );
    }

    renderBuyAGetBTab = () => {
      const buyAGetBTitle = (<Translate value="by_quantity_product" />);
      return (
        <Tab eventKey="BuyAGetB" title={buyAGetBTitle}>
        <div className="buy-a-get-b-tab">
          { this.renderBuyAGetBPromoDetails() }
        </div>
      </Tab>
      );
    }

    renderByTotalPriceProductTab = () => {
      const byTotalPriceProductTitle = (
        <span>
          <Translate value="by_total_price" /> (<Translate value="product" />)
        </span>
      );
      return (
        <Tab eventKey="ByTotalPriceProduct" title={byTotalPriceProductTitle}>
          <div className="by-total-price-product-tab">
            { this.renderByTotalPriceProductPromoDetails() }
          </div>
        </Tab>
      );
    }

    renderByTotalPriceDiscountTab = () => {
      const byTotalPriceDiscountTitle = (
        <span>
          <Translate value="by_total_price" /> (<Translate value="discount" />)
        </span>
      );
      return (
        <Tab eventKey="ByTotalPriceDiscount" title={byTotalPriceDiscountTitle}>
          <div className="by-total-price-discount-tab">
            {/* { this.renderByTotalPriceDiscountPromoDetails() } */}
          </div>
        </Tab>
      );
    }

    renderByQuantityPromoDetails = () => (
      <div className="promo-section" style={{ width: '100%' }}>
        <PromotionSetup
          setStartDate={this.setStartDate}
          startDateSelected={this.state.startDateSelected}
          setEndDate={this.setEndDate}
          endDateSelected={this.state.endDateSelected}
          handleSelectionChange={this.handleSelectionChange}
          customerGroupSelected={this.state.customerGroupSelected}
          paymentTypeSelected={this.state.paymentTypeSelected}
          customerOptions={this.getCustomerOptions()}
        />
        <ByQuantityFields
          paymentTypeSelected={this.state.paymentTypeSelected}
          methodSelected={this.state.methodSelected}
          quantityFrom={this.state.quantityFrom}
          quantityTo={this.state.quantityTo}
          discountValue={this.state.discountValue}
          discountType={this.state.discountType}
          handleSelectionChange={this.handleSelectionChange}
          handleTextInputChange={this.handleTextInputChange}
          handleDiscountButtonClick={this.handleDiscountButtonClick}
        />
        <SpinnerButton
          bsStyle="success"
          className="save-button"
          onClick={this.handleSavePromotion}
          disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByQuantity')}
          loading={this.state.isLoadingSavePromotion}
          icon="fa-save"
          translation={<Translate value="save" />}
        />
      </div>
    );

    renderBuyAGetBPromoDetails = () => (
      <div className="promo-section" style={{ width: '100%' }}>
        <PromotionSetup
          setStartDate={this.setStartDate}
          startDateSelected={this.state.startDateSelected}
          setEndDate={this.setEndDate}
          endDateSelected={this.state.endDateSelected}
          handleSelectionChange={this.handleSelectionChange}
          customerGroupSelected={this.state.customerGroupSelected}
          paymentTypeSelected={this.state.paymentTypeSelected}
          customerOptions={this.getCustomerOptions()}
        />
        <BuyAGetBFields
          methodSelected={this.state.methodSelected}
          productQuantityA={this.state.productQuantityA}
          productQuantityB={this.state.productQuantityB}
          discountValue={this.state.discountValue}
          discountType={this.state.discountType}
          handleSelectionChange={this.handleSelectionChange}
          handleDiscountButtonClick={this.handleDiscountButtonClick}
          handleTextInputChange={this.handleTextInputChange}
        />
        <SpinnerButton
          bsStyle="success"
          className="save-button"
          onClick={this.handleSavePromotion}
          // onClick={this.handleSavePromotionConfirm}
          disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'BuyAGetB')}
          loading={this.state.isLoadingSavePromotion}
          icon="fa-save"
          translation={<Translate value="save" />}
        />
      </div>
    );

    renderByTotalPriceProductPromoDetails = () => (
      <div className="promo-section" style={{ width: '100%' }}>
        <PromotionSetup
          setStartDate={this.setStartDate}
          startDateSelected={this.state.startDateSelected}
          setEndDate={this.setEndDate}
          endDateSelected={this.state.endDateSelected}
          handleSelectionChange={this.handleSelectionChange}
          customerGroupSelected={this.state.customerGroupSelected}
          paymentTypeSelected={this.state.paymentTypeSelected}
          customerOptions={this.getCustomerOptions()}
        />
        <ByTotalPriceProductFields
          minPurchasePrice={this.state.minPurchasePrice}
          handleTextInputChange={this.handleTextInputChange}
        />
        <SpinnerButton
          bsStyle="success"
          className="save-button"
          onClick={this.handleSavePromotion}
          disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByTotalPriceProduct')}
          loading={this.state.isLoadingSavePromotion}
          icon="fa-save"
          translation={<Translate value="save" />}
        />
      </div>
    );

    renderPromoDetails() {
      const that = this;
      if (this.state.promotionDetailsIsLoading) return <Spinner />;
      // else if (this.props.promotionDetailsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.promotionDetailsError)}</div></ContentWrapper>
      // Parameters of the react-data-grid
      const tableHeight = (window.innerHeight < 900) ? 200 : 200;
      const getRows = () => Data.Selectors.getRows(this.state.promotionDetails);
      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const promotionDetails = Object.assign({}, this.state.promotionDetails, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState({ promotionDetails });
      }
      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.promotionDetails.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const promotionDetails = {...this.state.promotionDetails, filters: newFilters};
        this.setState({ promotionDetails });
      }

      const onRowsDeselected = (rows) => {
        let newRows = this.state.promotionDetails.rows;
        rows.map (r => {
         newRows[r.rowIdx].isSelected = false;
        });
        var promotionDetails = {...this.state.promotionDetails, rows: newRows};
        this.setState({promotionDetails});
      }

      const onRowClick = (rowIdx, row) => {
        this.openEditPromotion();
        this.props.resetCurrentPromotions();
        this.handleFetchPromotionDetails(row.Promotion_id);
      }

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let date = new Date(this.props.value)
            let index = dateMap.indexOf(date.toString().slice(4, 3));
            let localDate = index + date.toString().slice(8, 6);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        }
      });

      const DeleteButtonFormatter = React.createClass({
        render() {
          return (
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  const { dependentValues } = this.props;
                  that.openDeletePromotion(dependentValues.PromotionLine_id);
                }}
              >
                X
              </Button>
            </span>
          );
        },
      });

      const EditButtonFormatter = React.createClass({
        render() {
          return (
            <span>
              <Button
                bsStyle="warning"
                className="textAlignStyle"
                style={{ height: '23px', width: '45px', padding: '0px' }}
                onClick={() => {
                  const { dependentValues } = this.props;
                  that.handleOpenEditPromotion(dependentValues.PromotionLine_id);
                }}
              >
                <Translate value="edit" />
              </Button>
            </span>
          );
        },
      });

      // Column difinition
      const columns = [
        {
          key: 'Delete',
          name: <Translate value="del" />,
          width: 50,
          formatter: DeleteButtonFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Edit',
          name: <Translate value="edit" />,
          width: 55,
          formatter: EditButtonFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'DiscountDescription',
          name: <Translate value="discount_description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 260,
        },
        {
          key: 'StartDate',
          name: <Translate value="start_date" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'EndDate',
          name: <Translate value="end_date" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: DateFormatter,
        },
      ];

      return (
        <Row>
          <Col xs={12}>
            <div id="ProductForm-dataGrid1">
              <ReactDataGrid
                rowKey="Promotion_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowHeight={25}
                headerRowHeight={30}
                minHeight={tableHeight}
                rowsCount={getSize()}
                // onRowClick={onRowClick}
             />
            </div>
          </Col>
        </Row>
      );
    }

    renderGroups() {
      const productGroupOptions = this.getProductGroupOptions();
      return (
        <Row className="formRow">
          <Col xs={3}>
            <label><Translate value={ isSoleStage() ? "brand" : "group" } /></label>
          </Col>
          <Col xs={9}>
            {
              (!this.props.currentProduct && !this.props.params.id)
              ?
                <Field
                  name="ProductGroup_id"
                  component={Selection}
                  withRef={true}
                  ref="ProductGroup"
                  options={productGroupOptions}
                  onKeyPress={(event) => {
                    if (event.keyCode == 13) {
                      this.refs["ProductCat1"].getRenderedComponent().refs.select.focus();
                    }
                  }}
                />
              :
                <Field name="ProductGroup_id" component={DisabledSelection} options={productGroupOptions} />
            }
          </Col>
        </Row>
      );
    }

    getProductGroupOptions() {
      var productGroupOptions = [];
      if (this.props.groups) {
        this.props.groups.map(group => {
          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name })
        });
      }
      return productGroupOptions;
    }

    CRV() {
      let CRVOptions = this.getCRVOptions();
      return (
        <Field name="CRV_id" component={ Selection } withRef={true} ref="CRVOptions" options={CRVOptions} onKeyPress={(event) => {
          if (event.keyCode == 13)
            ReactDOM.findDOMNode(this.refs["MeasureUnit"].getRenderedComponent().myInput.refs.input).focus();
        }}/>
      )
    }

    getCRVOptions() {
      var CRVOptions = [];
      this.props.CRVs.map(CRV => {
        CRVOptions.push({ value: CRV.Product_id, label: CRV.Name});
      });
      return CRVOptions;
    }

    renderDefaultBuyers() {
      const defaultBuyerOptions = this.getDefaultBuyerOptions();
      return (
        <Field name="Purchaser_User_id" withRef={true} ref="defaultBuyerOptions" component={Selection} options={defaultBuyerOptions} onKeyPress={(event) => {
            if (event.keyCode == 13)
              ReactDOM.findDOMNode(this.refs["MeasureUnit"].getRenderedComponent().myInput.refs.input).focus();
        }} />
      );
    }

    defaultSales() {
      const defaultBuyerOptions = this.getDefaultBuyerOptions();
      return (
        <Field name="Sales_User_id" component={Selection} options={defaultBuyerOptions} />
      );
    }

    getDefaultBuyerOptions() {
      return this.props.defaultBuyers.map((defaultBuyer) => {
        return {
          value: defaultBuyer.BaseUser_id,
          label: defaultBuyer.username,
        };
      });
    }

    renderCategories() {
      let productCategoryOptions = this.getProductCategoryOptions();
      let productCategory2Options = this.getProductCategory2Options();
      return (
        <div>
          <Row className="formRow">
            <Col xs={3}>
              <label><Translate value={isSoleStage() ? "style" : "category_1" }/></label>
            </Col>
            <Col xs={9}>
              {
                !this.props.currentProduct  && !this.props.params.id ?
                  <Field name="ProductCategory1_id" className="control-label" component={Selection} withRef={true} ref="ProductCat1" options={productCategoryOptions} onKeyPress={(event) => {
                    if (event.keyCode == 13) {
                      this.refs["ProductCat2"].getRenderedComponent().refs.select.focus();
                    }
                  }}/> :
                  <Field name="ProductCategory1_id" className="control-label" component={DisabledSelection}  options={productCategoryOptions} />
              }
            </Col>
          </Row>
        </div>
      );
    }

    renderDisplayCategories() {
      if (this.props.params.id) {
        return (
          <div>
            <Row>
              <Col xs={3}>
                <label><Translate value="display"/></label>
              </Col>
                <Col xs={9}>
                  <SpinnerButton
                    bsStyle="primary"
                    icon="fa-pencil"
                    onClick={this.handleDisplayCategoryBoxClick}
                    disabled={this.state.isLoadingDisplayCategory}
                    loading={this.props.editCategoryLoading}
                    translation={<Translate value="edit_display_category" />}
                  />
                </Col>
            </Row>
          </div>
        );
      } else {
        return (
          <div>
            <Row>
              <Col xs={3}>
                <label><Translate value="display" /></label>
              </Col>
              <Col xs={9}>
                <span style={{ color: 'red' }}><Translate value="edit_display_category_warning" /></span>
              </Col>
            </Row>
          </div>
        );
      }
    }

    renderBrandInformation = () => {
      return (
        <div>
          <Row>
            <Col xs={4}></Col>
            <Col xs={4}>
              <label>English</label>
            </Col>
            <Col xs={4}>
              <label>繁體</label>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Brand"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Brand" withRef={true} ref="English_Details_Brand" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Brand" withRef={true} ref="Chinese_Details_Brand" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Brand Origin"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Brand_Origin" withRef={true} ref="English_Brand_Origin" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Brand_Origin" withRef={true} ref="Chinese_Brand_Origin" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Net Content"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_NetContent" withRef={true} ref="English_Details_NetContent" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_NetContent" withRef={true} ref="Chinese_Details_NetContent" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Made In"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Made_In" withRef={true} ref="English_Details_Made_In" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Made_In" withRef={true} ref="Chinese_Details_Made_In" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Ingredients"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Ingredients" withRef={true} ref="English_Details_Ingredients" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Ingredients" withRef={true} ref="Chinese_Details_Ingredients" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Organic"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Organic" withRef={true} ref="English_Details_Organic" component={ InputField } placeholder="EN" />
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Organic" withRef={true} ref="Chinese_Details_Organic" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Contains Sugar"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Contains_Sugar" withRef={true} ref="English_Details_Contains_Sugar" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Contains_Sugar" withRef={true} ref="Chinese_Details_Contains_Sugar" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Flavor"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Flavor" withRef={true} ref="English_Details_Flavor" component={ InputField } placeholder="EN" />
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Flavor" withRef={true} ref="Chinese_Details_Flavor" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
        </div>
      )
    }

    getProductCategoryOptions() {
      var productCategoryOptions = [];
      this.props.groupCategories.map(category => {
        productCategoryOptions.push({ value: category.ProductCategory_id, label: category.Name })
      });
      return productCategoryOptions;
    }

    getProductCategory2Options() {
      var productCategory2Options = [];
      if (this.props.categories2) {
        this.props.categories2.map(category2 => {
          productCategory2Options.push({ value: category2.ProductCategory2_id, label: category2.Name })
        });
      }
      return productCategory2Options;
    }

    getZoneOptions() {
      let zoneOptions = [];
      this.props.zones.map( zone => {
        zoneOptions.push({value: zone.zone_num, label: zone.zone_num}); 
      });
      zoneOptions.sort( (a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return zoneOptions;
    }

    getBinOptions = () => {
      let binOptions = [];
      if (this.props.bins) {
        this.props.bins.map( bin => {
          binOptions.push({value: bin.section_num, label: bin.section_num});
        });
      }
      binOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return binOptions;
    }
    getBin2Options = () => {
      let binOptions = [];
      if (this.props.bins2) {
        this.props.bins2.map( bin => {
          binOptions.push({value: bin.section_num, label: bin.section_num});
        });
      }
      binOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return binOptions;
    }
    getBin3Options = () => {
      let binOptions = [];
      if (this.props.bins3) {
        this.props.bins3.map( bin => {
          binOptions.push({value: bin.section_num, label: bin.section_num});
        });
      }
      binOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return binOptions;
    }

    getLevelOptions = () => {
      let levelOptions = [];
      if (this.props.levels) {
        this.props.levels.map( level => {
          levelOptions.push({value: level.bin_num, label: level.bin_num})
        });
      }
      levelOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return levelOptions;
    }
    getLevel2Options = () => {
      let levelOptions = [];
      if (this.props.levels2) {
        this.props.levels2.map( level => {
          levelOptions.push({value: level.bin_num, label: level.bin_num})
        });
      }
      levelOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return levelOptions;
    }
    getLevel3Options = () => {
      let levelOptions = [];
      if (this.props.levels3) {
        this.props.levels3.map( level => {
          levelOptions.push({value: level.bin_num, label: level.bin_num})
        });
      }
      levelOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return levelOptions;
    }

    renderVolumeDimension() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="dimension" /></label>
          <div className="col-xs-2">
            <Field
              name="DimensionHeight"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["DimensionLength"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="DimensionLength"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["DimensionWidth"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="DimensionWidth"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["DimensionHeight"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          {
            (!isPS && !isHMM && !isWIZ && !isJTB && !isTN && !isABCFF && !isAPO && !isElegant) &&
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value="(ft)" />
            </div>
          }
          {
            (isElegant) &&
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value="(inch)" />
            </div>
          }
          {
            (isPS || isWIZ || isTN || isABCFF || isAPO) &&
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value="(in)" />
            </div>
          }
        </div>
      );
    }

    renderTotalVolume() {
      return (
      <div className="form-group">
        <label className="col-xs-4"><Translate value="total_volume" /></label>
        <div className="col-xs-3">
          <Field
            name="Volume"
            className="control-label"
            component={InputField}
            withRef={true}
            ref="ProductType"
            // onKeyPress={(event) => {
            //   if (event.key === 'Enter') {
            //     this.refs["DimensionLength"].getRenderedComponent().refs.select.focus();
            //   }
            // }}
          />
        </div>
        {/* <div>
              <Translate value="(cubic inch)" />
            </div> */}
      </div>
      );
    }

    renderCBM() {
      const { DimensionUnit, DimensionHeight, DimensionLength, DimensionWidth } = this.props;
      
      let cbm = 0;
      if (DimensionUnit) {
        if (DimensionUnit === 'cm' || DimensionUnit.value === 'cm') {
          cbm = (DimensionHeight/100)*(DimensionLength/100)*(DimensionWidth/100);
          // cbm = cbm.toFixed(15);
          cbm = Math.round(cbm * 1000000000000) / 1000000000000
        }
        if (DimensionUnit === 'inch' || DimensionUnit.value === 'inch') {
          cbm = (DimensionHeight*0.0254)*(DimensionLength*0.0254)*(DimensionWidth*0.0254);
          cbm = Math.round(cbm * 1000000000000) / 1000000000000
        }
      } else {
        cbm = 'N/A';
      }

      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="CBM" /></label>
          <div className="col-xs-5">
             <input value={ cbm } disabled style={customizedInputStyle}/>

          </div>
          {/* <div>
                <Translate value="(cubic)" />
              </div> */}
        </div>
      );
    }

    renderCBMUnit() {
      const dimensionUnitOption = [
        { value: "inch", label: "inch"},
        { value: "cm", label: "cm"},
      ];
      
      return (
      <div className="form-group">
        <label className="col-xs-4"><Translate value="dimension_unit" /></label>
        <div className="col-xs-4">
          <Field name="DimensionUnit" component={ Selection } options={dimensionUnitOption} 
          onKeyPress={(event) => {
            setTimeout(() => {
              this.props.setValue('productForm', 'DimensionUnit', event.target.value);
            }, 200);
                                    //   event.stopPropagation();
                                    // if (event.keyCode == 13) {
                                    //   this.refs["PackageType"].getRenderedComponent().refs.select.focus();
                                    // }
                                  }}
                                  />
        </div>
        {/* <div>
              <Translate value="(cubic inch)" />
            </div> */}
      </div>
      );
    }

    renderProductType() {
      const typeOptions = [{
        value: 'Fixed',
        label: 'Fixed',
      },
      {
        value: 'Non-Fixed',
        label: 'Non-Fixed',
      },
      {
        value: 'Service',
        label: 'Service',
      },
      {
        value: 'Non-Product',
        label: 'Non-Product',
      },
      {
        value: 'Per-Pound',
        label: 'Per-Pound',
      }];
      const colorOptions = [{
        value: 'Black',
        label: 'Black',
      },
      {
        value: 'White',
        label: 'White'
      },
      {
        value: 'Red',
        label: 'Red'
      },
      {
        value: 'Gery',
        label: 'Gery'
      },
      {
        value: 'Blue',
        label: 'Blue'
      },
      {
        value: 'Pink',
        label: 'Pink'
      }]
      return isSoleStage(ROOT_URL) ? (
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="prod_type"/><span className="asteriksReq">*</span></label>
              <div className="col-xs-8">
                <Field name="ProductType" className="control-label" component={Selection} withRef={true} ref="ProductType" options={typeOptions} onKeyPress={(event) => {
                  if (event.keyCode === 13) {
                    this.refs["ProductColor"].getRenderedComponent().refs.select.focus();
                  }
                }}/>
              </div>
            </div>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-3"><Translate value="color"/><span className="asteriksReq"></span></label>
              <div className="col-xs-9">
                <Field name="ProductColor" className="control-label" component={Selection} withRef={true} ref="ProductColor" options={colorOptions} onKeyPress={(event) => {
                  if (event.keyCode === 13) {
                    this.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
                  }
                }}/>
              </div>
            </div>
          </Col>
        </Row>
      )
      :
      (
      <div className="form-group">
        <label className="col-xs-4"><Translate value="prod_type"/><span className="asteriksReq">*</span></label>
        <div className="col-xs-8">
          <Field name="ProductType" className="control-label" component={Selection} withRef={true} ref="ProductType" options={typeOptions} onKeyPress={(event) => {
            if (event.keyCode === 13) {
              this.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
            }
          }}/>
        </div>
      </div>
      )
    }

    // renderRelatedProduct() {
    //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
    //     else {
    //         let productOptions = this.getProductOptions();
    //         return (
    //             <Row>
    //                 <Col xs={ 12 }>
    //                     <div className="form-group">
    //                       <label className="col-xs-4"><Translate value="related_product"/></label>
    //                       <div className="col-xs-8">
    //                         <Field name="Related_Product_id" className="control-label" component={Selection} withRef={true} ref="RelatedProduct" options={productOptions} onKeyPress={(event) => {
    //                           if (event.keyCode == 13) {
    //                             this.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
    //                           }
    //                         }}/>
    //                       </div>
    //                     </div>
    //                 </Col>
    //             </Row>
    //         )
    //     }
    // }

    // getProductOptions() {
    //     var productOptions = [];
    //     this.props.products.map(product => {
    //         productOptions.push({ value: product.Product_id, label: product.Name })
    //     });
    //     return productOptions;
    // }

    renderWarehouse() {
      if (this.props.warehouseIsLoading) return <Spinner/> // If group is loading, show a spinner.
      else {
        let warehouseOptions = this.getWarehouseOptions();
        return (
          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label><Translate value="default_warehouse"/></label>
                <Field name="Default_Warehouse_id" component={Selection} options={warehouseOptions}/>
              </div>
            </Col>
          </Row>
        )
      }
    }

    getWarehouseOptions() {
        var warehouseOptions = [];
        this.props.warehouses.map(warehouse => {
            warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
        });
        return warehouseOptions;
    }

    getMeasureUnitOptions() {
      let measureUnitOptions = [];
      if (this.props.measurementUnitFetched) {
        this.props.measurementUnitFetched.map(measureUnit => {
          measureUnitOptions.push({value: measureUnit.Simple, label: measureUnit.Simple})
        })
      }
      return measureUnitOptions;
    }

    getPackageTypeOptions() {
      let packageTypeOptions = [];
      if (this.props.packageTypesFetched) {
        this.props.packageTypesFetched.map(packageType => {
          packageTypeOptions.push({value: packageType.Simple, label: packageType.Simple})
        })
      }
      return packageTypeOptions;
    }
    
    routerWillLeave(nextLocation) {
      if (this.state.dirty) return <Translate value="work_not_saved_warning" />
      this.props.clearSmallProdStatus();
    }

    // renderTypes() {
    //     let productTypeOptions = [
    //         { value: "Fixed", label: "Fixed" },
    //         { value: "Non-Fixed", label: "Non-Fixed" },
    //         { value: "Service", label: "Service" },
    //         { value: "Non-Product", label: "Non-Product" },
    //         { value: "Per-Pound", label: "Per-Pound" },
    //         { value: "Other", label: "Other" }
    //     ];
    //     return (
    //         <Col xs={ 6 }>
    //             <div className="form-group">
    //               <label><Translate value="product_type"/></label>
    //                 <Field name="ProductType" component={Selection} options={productTypeOptions}/>
    //             </div>
    //         </Col>
    //     )
    // }

    renderPackageInfo() {
      const packageTypeOptions = this.getPackageTypeOptions();
      return (
        <div className="form-group">
          <label className="col-xs-6">
            <Translate value="package_type"/> <span className="asteriksReq">*</span>
          </label>
          <div className="col-xs-6">
            <Field name="PackageType" className="control-label" component={Selection} withRef={true} ref="PackageType" options={packageTypeOptions} onKeyPress={(event) => {
                if (event.keyCode === 13) {
                  ReactDOM.findDOMNode(this.refs["NetWeight"].getRenderedComponent().myInput.refs.input).focus();
                }
              }}
            />
          </div>
        </div>
      )
    }

    // If the user was directed to the page with a parameter,
    // then this page is edit page. Otherwise this is a create
    // page.

    VPNCheck = (vendors = []) => {
      let allVPNHasVendorId = true;
      vendors.forEach(elem => {
        if(elem.Vendor_product_num && !elem.Vendor_id) {
          allVPNHasVendorId = false;
        }
      })
      return allVPNHasVendorId;
    }

    BarcodeCheck = (vendors = []) => {
      let barcodeNotEmpty = true;
      vendors.forEach(elem => {
        if(!elem.Code && elem.Vendor_id) {
          barcodeNotEmpty = false;
        }
      })
      // console.log('BarcodeCheck result', barcodeNotEmpty, vendors);
      return barcodeNotEmpty;
    }

    handleFormSubmit(formProps) {
      if(formProps.ShippingWeight < formProps.NetWeight) {
        this.setState({
          confirmModalVisibility: true,
          formProps,
        })
        return;
      }
      this.submitForm(formProps)
    }

    submitForm = (formProps) => {
      // Temp VPN and barcode validation
      let temp = [];
      if(!this.VPNCheck(formProps.Vendors)) {
        alert('Each VPN must has a vendor id. please check the barcode panel');
        return;
      };
      if (!this.BarcodeCheck(formProps.Vendors)) {
        if (!isAFG && !isMyuMyu && !isWecom && !isMMD) {
          alert('Barcode can not be empty');
          return;
        } else {
          formProps.Vendors.map(v => {
            if (!v.Code) {
              v.Code = "";
            }
            temp.push(v);
          });
          formProps.Vendors = temp;
        }
      };
      this.setState({ dirty: false });
      if (this.props.params.id) {
        if(!this.checkPermission("change_product")){
            this.props.editProduct(formProps, this.state);
          } else {
          alert("You have no permission!");
        }
      }
      else this.props.createProduct(formProps, this.state, this.state.productNavigation_1.ProductNum);
      if (isAFG || isMyuMyu) {
        setTimeout(() => {
          window.history.back();
        }, 500);
      }
    }

    refreshPage(event) {
      event.preventDefault();
      this.setState({ showProductCreatedOpen: false, editProductGroup: false });
      const { productSaved } = this.props;
      this.props.resetCurrentProduct();
      this.props.selectProduct(productSaved);
      this.context.router.push('/products/'+productSaved.Product_id);
    }

    viewPromotion = () => {
      this.setState(
        { viewPromotion: true },
        () => {
          this.handleFetchPromotionDetails(this.state.Product_id);
        }
      );
    }

    closeViewPromotion = () => {
      const state = clearForm(this.state);
      this.setState(state);
      this.setState({
        viewPromotion: false,
        startDateSelected: undefined,
        endDateSelected: undefined,
        customerGroupSelected: '',
        paymentTypeSelected: '',
        selectedProduct: {
          currentPackageSize: this.props.currentProductDetail.PackageSize,
          currentProdId: this.props.currentProductDetail.Product_id,
          currentProdName: this.props.currentProductDetail.Name,
          currentProdNum: this.props.currentProductDetail.ProductNum,
          currentProductCRV: this.props.currentProductDetail.CRV,
          currentProductDescription: this.props.currentProductDetail.Description,
          currentProductWeight: this.props.currentProductDetail.NetWeight,
          currentRefNum: this.props.currentProductDetail.RefNum,
          currentRefPrice: this.props.currentProductDetail.RefPrice,
          netWeight: this.props.currentProductDetail.NetWeight,
        }
      });
    }

    checkPermission(permission) {
        return false;
    }

    handlePercentageChange(priceLevelPercentage, event) {
      const price = calculatePriceLevelNormal(event.target.value, this.props.RefPriceValue, this.props.ArrivalPrice);
      const priceLevel = lowerFirst(priceLevelPercentageFieldsMap[upperFirst(priceLevelPercentage)]);
      this.setState({
        [priceLevel]: price,
        [priceLevelPercentage]: event.target.value,
      });
    }

    handlePriceChange(priceLevel, event) {
      const basePrice = (isEcity || isHMM || isUSPride || isATL || isRS) ? this.props.ArrivalPrice : null;
      const percentage = calculatePricePercentage(event.target.value, this.props.RefPriceValue, basePrice);
      const priceLevelPercentage = lowerFirst(priceLevelFieldsMap[upperFirst(priceLevel)]);
      this.setState({
        [priceLevel]: event.target.value,
        [priceLevelPercentage]: percentage,
      });
    }

    pushInventoryDetail() {
      this.props.selectInventory(this.props.currentProductDetail);
      this.context.router.push(`/inventories/detail/${this.props.currentProductDetail.Product_id}`);
    }

    handleImageUpdated = (updatedImage) => {
      this.setState({ updatedImage });
    }

    renderProductNum() {
      let p = this.props.currentProductDetail && this.props.currentProductDetail.ProductNum;
      let isDisabled = true;
      return(
        <div className="form-group" >
          <label className="col-xs-4" >
            <Translate value="product_num" />
          </label>
          <div className="col-xs-8" >
            <Field name="ProductNum" className="control-label" isDisabled={isDisabled} component={ ControllabledStateInputField } placeholder={p} onKeyPress={(event) => {
                this.handleKeyPress('GeneralNum', event)
              }}/>
          </div>
        </div>
      )
    }

    renderRefNumLabel() {
      if(isJML || isTN || isWIZ) {
        return <Translate value="sku"/>
      }
      if(isLO) {
        return <Translate value="item_num"/>
      }
      return <Translate value="ref_num"/>
    }
    
    generateRefNo = () => {
      let rNo;
      const { PackageType_2, MeasureUnit_2 } = this.props;
      if (!PackageType_2 && !MeasureUnit_2) {
        alert('Please fill out Pkg Size 1 and Pkg Size 2 to generate Reference Number.')
      } else if (isBD()) {
        if (!this.props.currentProductDetail) {
          const groupTag = this.props.ProductGroup_id.label;
          const catTag = this.state.productNavigation_1.ProductCategory1_id.label;
          rNo = `${groupTag}-${catTag}-${this.props.PackageType_2.label}-${this.props.MeasureUnit_2.label}`;
        } else {
          let matchedProductId = this.props.ProductGroup_id;
          let matchedCategoryId = this.props.currentProductDetail.ProductCategory1_id;
          const groupTag = this.props.groups.find((value) => {
            if (value.ProductGroup_id === matchedProductId) {
              return value;
            }
          });
          const catTag = this.props.groupCategories.find((value) => {
            if (value.ProductCategory_id === matchedCategoryId) {
              return value;
            }
          });
          rNo = `${groupTag.Name}-${catTag.Name}-${this.props.PackageType_2}-${this.props.MeasureUnit_2}`;
        }
      } else if (isSoleStage()) {
        if (!this.props.currentProductDetail) {
          const catTag = this.state.productNavigation_1.ProductCategory1_id.label;
          rNo = `${catTag}-${this.props.PackageType_2.label}/${this.props.MeasureUnit_2.label}`;
        } else {
          let matchedCategoryId = this.props.currentProductDetail.ProductCategory1_id;
          const catTag = this.props.groupCategories.find((value) => {
            if (value.ProductCategory_id === matchedCategoryId) {
              return value;
            }
          });
          rNo = `${catTag.Name}-${this.props.PackageType_2.value ? this.props.PackageType_2.value : this.props.PackageType_2}/${this.props.MeasureUnit_2.value ? this.props.MeasureUnit_2.value : this.props.MeasureUnit_2 }`; 
        }
      }
      this.props.change('RefNum', rNo);
    }

  renderGenerateReferenceNumber = () => {
    if (isBD()) {
      return (
        <div style={{ marginBottom: 8 }}>
          <Button
            bsStyle="primary"
            type="button"
            onClick={this.generateRefNo}
          >
            <em className="fa fa-save" />
            <Translate value="Generate Ref No" />
          </Button>
        </div>
      )
    }
  }

  renderLotNum = () => {
    if(isCNT) {
      return(
        <div className="form-group">
        <label className="col-xs-4"><Translate value="lot_number"/></label>
        <div className="col-xs-8">
          <Field name="LotNum" withRef={true} ref="CustomerNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
              this.handleKeyPress('Name', event)
          }}/>
        </div>
      </div>
      )
    }
  }

  handleFocusQty = (suggestProduct) => {
    this.state.suggestProduct = suggestProduct;
  }

  renderAutoSuggest() {
    return (
      <MixProductAutoSuggest
        value={this.state.suggestValue}
        onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
        handleKeyPress={this.handleKeyPress}
        handleFocusQty={this.handleFocusQty}
        SearchType={this.state.productSearchType}
      />
    );
  }

  renderAvgCost() {
    const showProductCost = () => {
      if ((isJML || isChinaTown || isRivera || isHMM) && checkPermissionLocal('no_show_product_cost')) {
        return false
      }
      return true
    }
    if (this.props.currentProductDetail) {
      let currentProductDetail = this.props.currentProductDetail;
      let netCost = currentProductDetail.NetCost;
      let productCost = currentProductDetail.ProductCost
      const message = `FOB: ${this.props.currentProductDetail.FOBUnitPrice}  <br>  CIF: ${this.props.currentProductDetail.CIFUnitPrice} `        
      if (isEcity) {
        return(
          <div>
            <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label className="col-xs-6"> <Translate value="Shipping_fee"/></label>
              <div className="col-xs-6">
                {/* <input value={this.props.currentProductDetail.ShippingFeeUnitPrice} disabled style={customizedInputStyle}/> */}
                <Field name="ShippingFeeUnitPrice" disabled={!checkPermission('change_shipping_misc')} className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label className="col-xs-6"> <Translate value="Misc_fee"/></label>
              <div className="col-xs-6">
                {/* <input value={this.props.currentProductDetail.MiscUnitPrice} disabled style={customizedInputStyle}/> */}
                <Field name="MiscUnitPrice" disabled={!checkPermission('change_shipping_misc')} className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            {
              showProductCost() && <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="prod_cost"/></label>
              <ReactTooltip multiline={true}/>
              <div className="col-xs-6">
                <Field name="ProductCost" className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            }
          </div>
        )
      } else if(isHMM || isUSPride || isATL || isRS) {
        if (checkPermission('hmm_view_arrival') || isUSPride || isATL || isRS) {
          return (
            <div>
              {
                showProductCost() &&
                <div>
                  <div className="form-group mb0">
                    <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                    <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="prod_cost" /></label>
                    <ReactTooltip multiline={true} />
                    <div className="col-xs-6">
                      <Field name="ProductCost" className="control-label" withRef={true} ref="ProductCost" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                        this.handleKeyPress('Shipping', event);
                      }} />
                    </div>
                  </div>
                  <div className="form-group mb0">
                    <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                    <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="Shipping_fee" /></label>
                    <ReactTooltip multiline={true} />
                    <div className="col-xs-6">
                      <Field name="ShippingFeeUnitPrice" className="control-label" withRef={true} ref="Shipping" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                        this.handleKeyPress('TaxAmount', event);
                      }} />
                    </div>
                  </div>
                  <div className="form-group mb0">
                    <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                    <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="tax_amount" /></label>
                    <ReactTooltip multiline={true} />
                    <div className="col-xs-6">
                      <Field name="TaxAmount" className="control-label" withRef={true} ref="TaxAmount" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                        this.handleKeyPress('Overhead', event);
                      }} />
                    </div>
                  </div>
                  <div className="form-group mb0">
                    <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                    <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="over_head" /></label>
                    <ReactTooltip multiline={true} />
                    <div className="col-xs-6">
                      <Field name="MiscUnitPrice" className="control-label" withRef={true} ref="Overhead" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                        this.handleKeyPress('RefPrice', event);
                      }} />
                    </div>
                  </div>
                </div>
              }
            </div>
          )
        } else {
          <div></div>
        }
      } else {
        return (
          <div>
            {
              showProductCost() && <div className="form-group">
                <label className="col-xs-6"><Translate value="avg_cost"/></label>
                <div className="col-xs-6">
                  <Field name="InStockPrice" className="control-label" withRef={true} ref="InStockPrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('ProductCost', event);
                  }}/>
                </div>
              </div>
            }
            {
              showProductCost() && <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="prod_cost"/></label>
              <ReactTooltip multiline={true}/>
              <div className="col-xs-6">
                <Field name="ProductCost" className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            }
          </div>
        )
      }
    } else {
      return (
        <div>
          {
            showProductCost() && <div className="form-group">
              <label className="col-xs-6"><Translate value="inv_cost"/></label>
              <div className="col-xs-6">
                <Field name="NetCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="NetCost" onKeyPress={(event) => {
                    this.handleKeyPress('ProductCost', event)
                }}/>
              </div>
            </div>
          }
          {
            showProductCost() && <div className="form-group mb0">
              <label className="col-xs-6"><Translate value="prod_cost"/></label>
              <div className="col-xs-6">
                <Field name="ProductCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="ProductCost" onKeyPress={(event) => {
                    this.handleKeyPress('RefPrice', event)
                }}/>
              </div>
            </div>
          }
        </div>
      )
    }
  }

  // renderCancelLink() {
  //   let originPage = this.props.originPage || "products";
  //   let link = `/${originPage}`
  //   return (
  //     <Link to={link} className="btn btn-danger buttonStyle"><Translate value="exit"/></Link>
  //   )
  // }

  renderCloseButton() {
    if (this.props.originPage === 'products') {
      return (
        <Button bsStyle="danger" type="button" onClick={() => { this.setState({ showProductCreatedOpen: false }); this.context.router.push(`/${this.props.originPage}`); }} type="button" ><Translate value="no" /></Button>
        )
    }
    if (!this.props.originPage || this.props.originPage === 'inventories') {
      return (
        <Button bsStyle="danger" type="button" onClick={() => { this.setState({ showProductCreatedOpen: false }); window.history.back(); }} type="button" ><Translate value="no" /></Button>
      )
    }
  }

  renderImage() {
    let newImageFile = (this.state.files && this.state.files[0].preview)
    let ImageFile = ((this.state.updatedImage || (this.props.currentProductDetail && this.props.currentProductDetail.Thumbnail)) || '/img/dummy.png');
    if (newImageFile) {
      return (
        <div className="product-img-editor">
          <Editor
            image={newImageFile}
            upload={this.props.attachProductImage}
            Product_id={this.props.currentProductDetail && this.props.currentProductDetail.Product_id}
            clearAttachedProductImage={this.props.clearAttachedProductImage}
            width={100}
            height={100}
          />
        </div>
      )
    }
    return (
      <div className="product-img-view">
        <img src={ImageFile} alt="Upload image" className="img-thumbnail" />
      </div>
    )
  }

  checkPasscode = (e) => {
    e.preventDefault()
    this.props.setConfirmPasscodeModalVisibility(true);
  }

  setProductMetaInfoVisibility = (isVisible) => {
    this.setState({
      productMetaInfoVisibility: isVisible
    })
  }

  handleProductMetaInfoSave = (info) => {
    this.setState({
      meta_info: info,
    }, () => {
      this.setProductMetaInfoVisibility(false);
    });
  }

  handleFetchESL = () => {
    let productId = this.props.currentProductDetail.Product_id;
    this.props.fetchESL(productId)
      .then((response) => {
        this.setState({ eslFetchData: response.data });
      }, (err) => {
        alert("ESL Error: " + err.data);
      });
  }
  handleSaveESL = (ESLCode, TemplateId, TemplateName) => {
    let productId = this.props.currentProductDetail.Product_id;
    this.props.saveESL(productId, ESLCode, TemplateId, TemplateName)
      .then((response) => {
        alert("ESL Bind Successful");
        this.setState({ eslModalVisibility: false });
      }, (err) => {
        alert("ESL Error: " + err.data);
      });
  }

  render() {
    const productDetailsPanelHeader = (<h2><Translate value="basic_info" /></h2>);
    const packageDetailsPanelHeader = (<h2><Translate value="packaging" /></h2>);
    const zonePricePanelHeader = (<h2><Translate value="zone_price_levels" /></h2>);
    const mixProductPanelHeader = (<h2><Translate value="mix_product" /></h2>)
    const costsDetailsPanelHeader = (<h2><Translate value="cost" /></h2>);
    const saleDetailsPanelHeader = (<h2><Translate value="sale" /></h2>);
    const buyerDetailsPanelHeader = (<h2><Translate value="purchase" /></h2>);
    const convertDetailsPanelHeader = (<h2><Translate value="convert" /></h2>);
    const inventoryDetailsPanelHeader = (<h2><Translate value="inventory" /></h2>);
    const vendorPanelHeader = (<h2><Translate value="barcode" /></h2>);
    const productInformation = (<Translate value="product_information" />);
    const inventoryInformation = (<Translate value="inventory_information" />);
    const productCostAndPrice = (<Translate value="product_cost_and_price" />);
    const packageAndWeight = (<Translate value="package_slashsign_weight" />);
    const bardcodeTranslation = (<Translate value="barcode" />);
    const productGroupAndCategory = (<Translate value="product_group_and_category" />);
    const productDetail = (<Translate value="product_detail" />);
    const productDetailsHeader = (<h2><Translate value="product_details" /></h2>);
    const viewPromotionHeader = (<Translate value="view_promotions" />);
    const editRecPermissionChange = (<Translate value="permission_for_changing_product_number" />);
    const editRecPermissionDuplicate = (<Translate value="permission_for_duplicating_product" />);
    const editGroupFormChangeGroupTitle = (<Translate value="edit_group" />);
    const editGroupFormDuplicateProdTitle = (<Translate value="duplicate_product" />);
    const mobileDescBoxTitle = (<Translate value="mobile_description_box" />);
    const displayCategoryBoxTitle = (<Translate value="edit_display_category" />);
    const imagesModalTitle = (<Translate value="upload_images" />);
    const addConvertProductsTitle = (<Translate value="products" />)
    const deleteProduct = (<Translate value="delete_product" />);
    const editPromotionTitle = <Translate value="edit_promotion" />;
    const skusModalTitle = <Translate value="skus" />;
    const productMetaInfoTitle = <Translate value="edit_product_meta" />;
    const eslTitle = <Translate value="edit_esl" />;
    const productGroupPanelHeader = (
      <h2>
        <Translate value="packaging" />
        {
          (this.props.currentProduct)
          ?
          <Button bsStyle="warning" className="edit-product-group-button" onClick={this.openEditRecPermission}>
            <em className="fa fa-pencil"></em>
          </Button>
          :
          <span />
        }
      </h2>
    );
    const { handleSubmit, invalid, submitting, pristine } = this.props;

    const createDialogStyle = {
      width: '650px',
      marginLeft: '-15%',
    };
    const createLargeDialogStyle = {
      width: '850px',
      height: '530px',
      marginLeft: '-25%',
    };
    const createDisplayCategoryDialogStyle = {
      width: '700px',
      height: '500px',
      marginLeft: '-15%',
    };
    const promotionsStyle = {
      width: '800px',
      height: '480',
      marginLeft: '-15%',
    };
    const deletePromotionDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-10%',
      marginTop: '-100px',
    };
    const editPromotionDialog = {
      width: '550px',
      height: '300px',
      marginLeft: '-10%',
      marginTop: '-100px',
    };
    const imagesModalStyle = {
      width: '700px',
      height: '700px',
      top: '30%',
      marginLeft: '-15%',
    };
    const convertProductListStyle = {
      width: '800px',
      height: '470px',
      marginLeft: '-20%',
    };
    const createProductMetaStyle = {
      width: '700px',
      height: '280px',
      marginLeft: '-15%',
    };
    const createESLStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };

    const renderRichTextEditor = () => {
      if(isSY) {
        return <SkyLightStateless
          dialogStyles={createLargeDialogStyle}
          isVisible={this.state.mobileDescBoxOpen}
          onCloseClicked={() => { this.closeMobileDescBox(); }}
          title={mobileDescBoxTitle}
        >
          <TuiEditor
            htmlString={this.state.mobileDescriptionHTML}
            placeholder="Enter the product description."
            saveHtml={(htmlText) => { this.saveRichText(htmlText); }}
            isLoadingSave={this.props.isLoadingDescriptionBoxSave}
            saveSuccess={this.props.saveMobileDescriptionTextSuccess}
          />
        </SkyLightStateless>
      }
      return <SkyLightStateless
        dialogStyles={createDialogStyle}
        isVisible={this.state.mobileDescBoxOpen}
        onCloseClicked={() => { this.closeMobileDescBox(); }}
        title={mobileDescBoxTitle}
      >
        <RichTextEditor
          htmlString={this.state.mobileDescriptionHTML}
          placeholder="Enter the product description."
          saveHtml={(htmlText) => { this.saveRichText(htmlText); }}
          isLoadingSave={this.props.isLoadingDescriptionBoxSave}
          saveSuccess={this.props.saveMobileDescriptionTextSuccess}
        />
      </SkyLightStateless>
    }
    if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...reading data</ContentWrapper>
    else {
      let measureUnitOptions = this.getMeasureUnitOptions();
      let getZoneOptions = this.getZoneOptions();
      let getBinOptions = this.getBinOptions();
      let getLevelOptions = this.getLevelOptions();
      // let getZone2Options = this.getZone2Options();
      let getBin2Options = this.getBin2Options();
      let getLevel2Options = this.getLevel2Options();
      // let getZone3Options = this.getZone3Options();
      let getBin3Options = this.getBin3Options();
      let getLevel3Options = this.getLevel3Options();
      let packageTypeOptions = this.getPackageTypeOptions();
      const url = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForLabel = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode2/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForLargeLabelWin = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_large/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForLargeLabelMac = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_large_mac/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForSmallLabelWin = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_small/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForSmallLabelMac = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_small_mac/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      let editGroupFormSaveAction;
      let editGroupFormSaveActionCallback;
      let editRecPermission;
      let editGroupFormTitle;
      if (this.state.editGroupFormAction === 'duplicate') {
        editGroupFormSaveAction = this.props.duplicateProduct;
        editGroupFormSaveActionCallback = () => {};
        editRecPermission = editRecPermissionDuplicate;
        editGroupFormTitle = editGroupFormDuplicateProdTitle;
      } else if (this.state.editGroupFormAction === 'changeGroup') {
        editGroupFormSaveAction = this.props.updateProductGroup;
        editGroupFormSaveActionCallback = this.props.fetchProductDetail;
        editRecPermission = editRecPermissionChange;
        editGroupFormTitle = editGroupFormChangeGroupTitle;
      }

      return (
        //---------------
        // Begin HTML: Create New/Edit Purchase Order
        //---------------
        <ContentWrapper>
          <form className="form-horizontal" method="get" action="#" onSubmit={() => { console.log('attempting to submit')}} >
            {/* Navigation Trail */}
            <Breadcrumb style={this.state.crumbStyle}>
              <Breadcrumb.Item>
                <Translate value="general_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/products"><Translate value="products" /></Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="edit_product" />
              </Breadcrumb.Item>
              <span style={{ color: 'red', display: 'inline', 'padding-left': '30px' }}>{(this.props.detailError) ? 'Product does not exist': ''}</span>
            </Breadcrumb> {/* End Navigation Trail */}
            {/* Product Header Nav */}
            <div id="search-product-header-nav">
              {/* <Row style={{ "margin-right": "50%" }}> */}
              <Row style={{ marginRight: isEcity ? "770px" : "45%" }}>
                {/* <Col xs={1} xsOffset={3}> */}
                <Col xs={1}>
                  <span style={{ display: "inline" }} className="fa fa-arrow-circle-left btn-lg prev-arrow" onClick={() => {
                    if (this.props.currentProductDetail && checkPermission('change_product')) {
                      this.setState({ updatedImage: undefined });
                      if (isHMM) {
                        this.props.fetchPreviousProductWithGeno(this.props.currentProductDetail.GeneralNum);
                        return;
                      } 
                      this.props.fetchPreviousProduct(this.props.currentProductDetail.ProductNum);
                    }
                  }}
                  >
                  </span>
                </Col>
                <Col xs={4} className="centerStyle" style={{ 'width': '37%' }}>
                  <Field
                    style={{ display: "inline", 'max-width': "100%" }}
                    name={ isHMM ? "GeneralNumber" : "ProductNumber"}                    
                    component={InputField}
                    disabled={!checkPermission('change_product')}
                    onKeyPress={(event) => {
                      if (event.charCode == 13) {
                        event.preventDefault();

                        // if (this.props.ProductNumber === this.props.ProductNum) {
                        //   alert('please search using different product number')
                        //   return;
                        // }
                        this.setState({ updatedImage: undefined });
                        this.props.fetchProductByNum(this.props.ProductNumber, { isHMM, GeneralNumber: this.props.GeneralNumber });
                      }
                    }}
                  />
                 </Col>
                 <Col xs={1}>
                  <span style={{ display: "inline" }} className="fa fa-arrow-circle-right btn-lg next-arrow" onClick={() =>{
                    if (this.props.currentProductDetail && checkPermission('change_product')) {
                      this.setState({ updatedImage: undefined });
                      if (isHMM) {
                        this.props.fetchNextProductWithGeno(this.props.currentProductDetail.GeneralNum);
                        return;
                      }
                      this.props.fetchNextProduct(this.props.currentProductDetail.ProductNum);
                    }
                  }}>
                  </span>
                </Col>
              </Row>
            </div> {/* End Product Header Nav */}

            {/* Button Actions */}
            <ButtonToolbar id="breadcrumbButtonGroup">
            {
              (!isEcity || checkPermission('delete_product')) &&
              <span>
                <Button
                  type="button"
                  bsStyle="danger"
                  onClick={this.openDeleteModal}
                >
                  <em className="fa" /><Translate value="delete" />
                </Button>
                <Button
                  type="button"
                  bsStyle="warning"
                  onClick={() => {
                    if (this.props.currentProductDetail) {
                      if (this.props.currentProductDetail.IsDiscontinued) {
                        this.props.continueProduct(this.props.currentProductDetail.Product_id);
                      } else {
                        this.props.discontinueProduct(this.props.currentProductDetail.Product_id);
                      }
                    }
                  }}
                >
                  <Translate value={this.props.currentProductDetail && this.props.currentProductDetail.IsDiscontinued ? 'continue_product' : 'discontinue'} />
                </Button>
              </span>
            }
              <Button
                type="button"
                bsStyle="primary"
                onClick={this.viewPromotion}
                disabled={!this.state.Product_id}
              >
                <em className="fa fa-eye" /><Translate value="promo" />
              </Button>
              <Button
                type="button"
                bsStyle="primary"
                className="textAlignStyle"
                href={url}
                disabled={!this.props.currentProduct && !this.props.params.id}
              >
                <em className="fa fa-print" /><Translate value="barcode" />
              </Button>
              {
                !isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForLabel}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="label" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForSmallLabelWin}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="small_label_win" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForSmallLabelMac}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="small_label_mac" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForLargeLabelWin}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="large_label_win" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForLargeLabelMac}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="large_label_mac" />
                </Button>
              }
              <Button
                type="button"
                bsStyle="primary"
                onClick={this.pushInventoryDetail.bind(this)}>
                <em className="fa fa-eye" /><Translate value="inv" />
              </Button>
              <Button
                type="button"
                action="submit"
                bsStyle="success"
                onClick={handleSubmit(this.handleFormSubmit.bind(this))}
                disabled={ invalid || submitting || pristine }
              >
                <em className="fa fa-save" /><Translate value="save" />
              </Button>
              <Button
                type="button"
                bsStyle="danger"
                onClick={() => window.history.back()}
                //onClick={(event) => { this.context.router.push(`/${this.props.originPage || "products"}`) }}
              >
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar> {/* End Button Actions */}
            <div className="formContainer">
              {/* if discontinued render a transparent overlay that prevent use */}
              {
                this.props.currentProductDetail && this.props.currentProductDetail.IsDiscontinued &&
                <div className="overlay"></div>
              }
              <Grid id="manage-products">
                {/* Row Wrapper */}
                <Row className="row-wrapper">
                  {/* Product Details Column */}
                  <Col xs={4}>
                    <Row>
                      <Col xs={12}>
                        {/* Product Details Panel */}
                        <Panel id="product-details" header={productDetailsPanelHeader}>
                          <Row>
                            {/* Product No. Input Fields */}
                            <Col xs={7} className="pr0 ">
                              {this.renderProductNum()}
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value={(isMyuMyu || isAFG) ? "index_no":"general_no"}/></label>
                                <div className="col-xs-8">
                                  <Field name="GeneralNum" withRef={true} ref="GeneralNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('RefNum', event)
                                  }}/>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-4">
                                  {this.renderRefNumLabel()}
                                </label>
                                <div className="col-xs-8">
                                  <Field style={{ marginBottom: 8 }} name="RefNum" withRef={true} ref="RefNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('CustomerNum', event)
                                  }}/>
                                </div>
                                {this.renderGenerateReferenceNumber()}
                              </div>
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="vendor_no"/></label>
                                <div className="col-xs-8">
                                  <Field name="VendorProdNo" withRef={true} ref="CustomerNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      if (isAFM) {
                                        this.handleKeyPress('Brand', event)
                                        return;
                                      }
                                      this.handleKeyPress('Name', event)
                                  }}/>
                                </div>
                              </div>
                              {this.renderLotNum()}
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="brand"/></label>
                                <div className="col-xs-8">
                                  <Field name="Brand" withRef={true} ref="Brand" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('Name', event)
                                  }}/>
                                </div>
                              </div>

{isSW &&
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="color"/></label>
                                <div className="col-xs-8">
                                  <Field name="Color" withRef={true} ref="Color" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('Name', event)
                                  }}/>
                                </div>
                              </div>
    }
{isSW &&

                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="size"/></label>
                                <div className="col-xs-8">
                                  <Field name="Size" withRef={true} ref="Size" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('Name', event)
                                  }}/>
                                </div>
                              </div>
    }

                              {
                                isPTS &&
                                <div className="form-group">
                                <label className="col-xs-5"><Translate value="mfr_no"/></label>
                                <div className="col-xs-7">
                                  <Field name="MFRNum" withRef={true} ref="MFRNum" disabled={true} component={ InputField } 
                                  />
                                </div>
                              </div>
                              }
                            </Col> {/* Product No. Input Fields */}

                            <Col xs={5}>
                              <div className="img-container">
                                {this.renderImage()}
                                <div className="product-img-uploader">
                                  <div className="well dropzone" >
                                    <Row>
                                      <Col xs={12}>
                                        <Button
                                          bsStyle="primary"
                                          type="button"
                                          className="pull-right"
                                          onClick={() => this.openImageModal()}
                                        >
                                          <em className={`fa ${this.state.isLoadingImages ? 'fa-spinner fa-spin' : 'fa-plus'}`} />
                                          {/* <Translate value="upload"/> */}
                                        </Button>
                                        {/* <SpinnerButton
                                          className="pull-right"
                                          bsStyle="primary"
                                          icon="fa-plus"
                                          onClick={() => this.fetchImages(() => this.openImageModal())}
                                          disabled={this.state.isLoadingImages}
                                          loading={this.state.isLoadingImages}
                                        /> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                                {
                                  this.props.attachingProductImage &&
                                  <div className="alert alert-info">
                                    <span><Translate value="saving"/></span>
                                  </div>
                                }
                                {
                                  this.props.productImageAttached &&
                                  <div className="alert alert-success">
                                    <span><Translate value="saved" /></span>
                                  </div>
                                }
                              </div>
                            </Col> {/* End Img Uploader */}
                            {/* Product Description Fields */}
                            {isFBD && <Col xs={12}>
                              <div className="form-group prod-name-input">
                                <label className="col-xs-3">
                                  <Translate value="customer"/><span className="asteriksReq">*</span>
                                </label>
                                <div className="col-xs-9">
                                  <Field name="customerId" component={Selection} options={this.props.customerOptions}/>
                                </div>
                              </div>
                            </Col>}
                            <Col xs={12}>
                              <div className="form-group prod-name-input">
                                {
                                  !isWecom &&
                                  <label className="col-xs-3"><Translate value="prod_name"/><span className="asteriksReq">*</span></label>
                                }
                                {
                                  isWecom &&
                                  <label className="col-xs-3"><Translate value="eng_name"/><span className="asteriksReq">*</span></label>
                                }
                                <div className="col-xs-9">
                                  <Field name="Name" withRef={true} ref="Name" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('Description', event)
                                  }}/>
                                </div>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <div className="form-group prod-name-input">
                                {
                                  !isWecom &&
                                  <label className="col-xs-3"><Translate value="description" /></label>
                                }
                                {
                                  isWecom &&
                                  <label className="col-xs-3"><Translate value="chi_name" /></label>
                                }
                                <div className="col-xs-9">
                                  <Field name="Description" withRef={true} ref="Description" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      if (event.charCode == 13) {
                                        event.preventDefault();
                                        this.refs["ProductGroup"].getRenderedComponent().refs.select.focus();
                                      }
                                  }}/>
                                </div>
                              </div>
                            </Col>
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="customer" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Customer" component={Selection} options={this.props.customerOptions}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="vendor_style" /></label>
                                  <div className="col-xs-9">
                                  <Field name="VendorStyleNum" withRef={true} ref="VendorStyleNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>        
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3">TJX Style</label>
                                  <div className="col-xs-9">
                                    <Field name="TJXStyleNum" withRef={true} ref="TJXStyleNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>        
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="upc" /></label>
                                  <div className="col-xs-9">
                                    <Field name="UPC" withRef={true} ref="UPC" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>        
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="gtin" /></label>
                                  <div className="col-xs-9">
                                    <Field name="GTIN" withRef={true} ref="GTIN" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>        
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="color" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Color" withRef={true} ref="Color" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>        
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3">Size/Ratio</label>
                                  <div className="col-xs-9">
                                    <Field name="Size" withRef={true} ref="Size" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>        
                                  </div>
                                </div>
                              </Col>
                            }

                            <Col xs={12}>
                              <div className="mobile-description-box-button">
                                <SpinnerButton
                                  bsStyle="primary"
                                  icon="fa-pencil"
                                  onClick={this.handleMobileDescBoxClick}
                                  disabled={this.state.isLoadingMobileDescBoxText}
                                  loading={this.state.isLoadingMobileDescBoxText}
                                  translation={<Translate value="mobile_description_box" />}
                                />
                                <SpinnerButton
                                  style={{ marginLeft: '10px' }}
                                  bsStyle="primary"
                                  icon="fa-pencil"
                                  onClick={this.handleSkusClick}
                                  disabled={this.state.skusModal}
                                  loading={this.state.skusModal}
                                  translation={<Translate value="skus" />}
                                />
                                <Button
                                  style={{ marginLeft: '10px' }}
                                  bsStyle="primary"
                                  onClick={() => { this.setProductMetaInfoVisibility(true) }}
                                >
                                  <em className="fa fa-pencil" /><Translate value="meta_info" />
                                </Button>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <div className="formSubHeaderContainer">
                                <Row>
                                  <Col xs={6}>
                                    <p className="formSubHeader"><Translate value="group" /> / <Translate value="category" /></p>
                                  </Col>
                                  <Col xs={1} xsOffset={3}>
                                    {
                                      (this.props.currentProduct || this.props.params.id) &&
                                        <Button
                                          bsStyle="primary"
                                          className="edit-product-group-button"
                                          onClick={() => this.openCheckAuthorize('duplicate')}
                                          style={{ position: "relative", left: "10px", zIndex: 5 }}
                                        >
                                          <em className="fa fa-copy"></em>
                                        </Button>
                                    }
                                  </Col>
                                  <Col xs={1}>
                                    {
                                      (this.props.currentProduct || this.props.params.id) &&
                                        <Button
                                          bsStyle="warning"
                                          className="edit-product-group-button"
                                          onClick={() => this.openEditRecPermission('changeGroup')}
                                          style={{ position: "relative", left: "18px" }}
                                        >
                                          <em className="fa fa-pencil"></em>
                                        </Button>
                                    }
                                  </Col>
                                </Row>
                              </div>
                              {this.renderGroups() }
                              {this.renderCategories() }
                              {(isAFG || isWecom || isHF) && this.renderDisplayCategories()}
                            </Col>
                          <Col xs={12}>
                            {isAFM && this.renderBrandInformation() }
                          </Col>
                          </Row>
                        </Panel> {/* End Product Details Panel */}
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12}>
                        {/* Package Details Panel */}
                        <Panel id="package-details" header={packageDetailsPanelHeader} style={{ height: '400px' }}>
                          <Row>
                            <Col xs={12}>
                              {this.renderProductType()}
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={6}>
                              {this.renderPackageInfo()}
                            </Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="measure_unit" /></label>
                                <div className="col-xs-6">
                                  <Field disabled={(isAFG && !isHF) || isMyuMyu || isWecom} name="MeasureUnit" className="control-label" component={ Selection } withRef={true} ref="MeasureUnit" options={measureUnitOptions} onKeyPress={(event) => {
                                      event.stopPropagation();
                                    if (event.keyCode == 13) {
                                      this.refs["PackageType"].getRenderedComponent().refs.select.focus();
                                    }
                                  }}/>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          {
                            !isHMM &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                  <label className="col-xs-4"><Translate value="net_wt"/></label>
                                  <div className="col-xs-4" style={{ paddingRight: 0 }}>
                                    <Field name="NetWeight" className="control-label" withRef={true} ref="NetWeight" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('ShippingWeight', event);}}
                                    />
                                  </div>
                                  <div className="col-xs-4" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                    <Field name="MeasureUnit" className="control-label" component={DisabledSelection}  options={measureUnitOptions} />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="ship_weight"/></label>
                                  <div className="col-xs-4" style={{ paddingRight: 0 }}>
                                    <Field name="ShippingWeight" className="control-label" withRef={true} ref="ShippingWeight" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('MinWeightRange', event)
                                    }}/>
                                  </div>
                                  <div className="col-xs-4" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                    <Field name="MeasureUnit" className="control-label" component={DisabledSelection}  options={measureUnitOptions} />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {
                            !isHMM && !isHF &&
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="weight_range"/></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="min" /></label>
                                  </Col>
                                  <Col xs={9}>
                                    <Field name="MinWeightRange" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="MinWeightRange" standalone type="text" standalone addonAfter=".00" onKeyPress={(event) => {
                                      this.handleKeyPress('MaxWeightRange', event)
                                    }} />
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={1} style={{ textAlign: 'center' }}>
                                <label><Translate value="~" /></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="max" /></label>
                                  </Col>
                                  <Col xs={9}>
                                    <Field
                                      name="MaxWeightRange"
                                      className="control-label"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      standalone
                                      type="text"
                                      addonAfter=".00"
                                      withRef={true}
                                      ref="MaxWeightRange"
                                      onKeyPress={(event) => {
                                        if (!this.props.currentProductDetail) {
                                          this.handleKeyPress('NetCost', event)
                                        } else {
                                          this.handleKeyPress('RefPrice', event)
                                        }
                                      }}
                                    />
                                  </Col>
                                </Row>
                            {/* End Weight Range */}
                              </Col>
                            </Row>
                          }
                          {
                            isHF &&
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="weight_range"/></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="min" /></label>
                                  </Col>
                                  <Col xs={5}>
                                    <Field name="MinWeightRange" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="MinWeightRange" standalone type="text" standalone addonAfter=".00" onKeyPress={(event) => {
                                      this.handleKeyPress('MaxWeightRange', event)
                                    }} />
                                  </Col>
                                  <Col xs={3}>
                                    <label><Translate value="lbs" /></label>
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={1} style={{ textAlign: 'center' }}>
                                <label><Translate value="~" /></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="max" /></label>
                                  </Col>
                                  <Col xs={5}>
                                    <Field
                                      name="MaxWeightRange"
                                      className="control-label"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      standalone
                                      type="text"
                                      addonAfter=".00"
                                      withRef={true}
                                      ref="MaxWeightRange"
                                      onKeyPress={(event) => {
                                        if (!this.props.currentProductDetail) {
                                          this.handleKeyPress('NetCost', event)
                                        } else {
                                          this.handleKeyPress('RefPrice', event)
                                        }
                                      }}
                                    />
                                  </Col>
                                  <Col xs={3}>
                                    <label><Translate value="lbs" /></label>
                                  </Col>
                                </Row>
                            {/* End Weight Range */}
                              </Col>
                            </Row>
                          }
                          {
                            isJTB &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderCBMUnit()}
                              </Col>
                            </Row>
                          }
                          {
                            isHF &&
                            <Row className="formRow">{/* Temperature */}
                              <Col xs={3}>
                                <label><Translate value="temperature"/></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={9}>
                                    <Field name="Temperature" className="control-label" component={InputField}/>
                                  </Col>
                                  <Col xs={1} style={{ textAlign: 'left' }}>
                                    <label><Translate value="°F" /></label>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>                                                           
                          }
                          <Row style={{ marginBottom: '-10' }}>
                            <Col xs={12}>
                              {this.renderVolumeDimension()}
                            </Col>
                          </Row>
                          {
                            isJTB &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderCBM()}
                              </Col>
                            </Row>
                          }
                          {
                            isWIZ &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderTotalVolume()}
                              </Col>
                            </Row>
                          }
                          {/* Package Size */}
                          {
                            !isHF &&
                            <div className="formSubHeaderContainer">
                              <Row>
                                <Col xs={3}>
                                  <p className="formSubHeader">
                                    <Translate value="package_size"/>
                                  </p>
                                </Col>
                                <Col xs={9}>
                                  <Field
                                    name="PackageSize"
                                    className="control-label"
                                    withRef={true}
                                    ref="PackageSize"
                                    component={DisabledInputField}
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {
                                      this.handleKeyPress('NetWeight', event)
                                    }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          }
                          {
                            isHF &&
                            <div>
                              <Row>
                                <label className="col-xs-3"><Translate value="packageSize"/></label>
                                <Col xs={9}>
                                  <Field
                                    name="PackageSize"
                                    component={InputField}
                                  />
                                </Col>
                              </Row>
                            </div>
                          }
                          {/* End Package Size */}
                          {
                            !isHF && 
                            <div>
                              <Row style={{ marginTop: '-6'}}>
                              <Col sm={2}><Field name="PackageSize_1" component={InputField} /></Col>
                                {
                                  !isEcity &&
                                  <Col sm={3} className="select-menu-drop-up"><Field name="PackageType_2" component={Selection} options={packageTypeOptions} /></Col>
                                }
                                {
                                  isEcity &&
                                  < Col sm={3}><Field name="PackageType_2" component={InputField} placeholder="Type"/></Col>
                                }
                                <Col sm={2} className="textAlignStyle"><em className="fa fa-times times-sign"/></Col>
                                <Col sm={2}><Field name="PackageSize_2" component={InputField} /></Col>
                                {
                                  !isEcity &&
                                  < Col sm={3} className="select-menu-drop-up"><Field name="MeasureUnit_2" component={Selection} options={measureUnitOptions} /></Col>
                                }
                                {
                                  isEcity &&
                                  < Col sm={3}><Field name="MeasureUnit_2" component={InputField} placeholder="Unit"/></Col>
                                }
                                </Row>
                              <Row className="nonbold-label-description textAlignStyle">
                                <Col sm={2}><Translate value="(num)"/></Col>
                                <Col sm={3}><Translate value={ isSoleStage() ? "us_size" : "(pkg_size_1)" }/></Col>
                                <Col sm={2}></Col>
                                <Col sm={2}><Translate value="(num)"/></Col>
                                <Col sm={3}><Translate value={ isSoleStage() ? "eu_size" : "(pkg_size_2)" }/></Col>
                              </Row>
                            </div>
                          }
                          {
                            (isCalco || isOCM) &&
                            <div>
                              <Row style={{ marginTop: '10' }}>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>1</label>
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Pallet</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '16px' }}>
                                  <label>=</label>
                                </Col>
                                <Col sm={2}><Field name="CalcoDispatchCase" component={InputField} /></Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Case</label>
                                </Col>
                              </Row>
                            </div>
                          }
                          {
                            isCalco &&
                            <div>
                              <Row style={{ marginTop: '5' }}>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>1</label>
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Case</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '16px' }}>
                                  <label>=</label>
                                </Col>
                                <Col sm={2}><Field name="CalcoDispatchBag" component={InputField} /></Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Bag</label>
                                </Col>
                              </Row>
                            </div>
                          }
                        </Panel> {/* End Package Details Panel */}
                      </Col>
                    </Row>
                    {(isFBD && this.props.currentProductDetail && this.props.currentProductDetail.ProductCategory1_id === 32)&&
                    <Row>
                      <Col xs={12}>
                        {/* Package Details Panel */}
                        <Panel id="package-details" header={zonePricePanelHeader} style={{ height: '330px' }}>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv2"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                <Field name="ZoneLevel2" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel2" standalone type="text" onKeyPress={(event) => {
                                  this.handleKeyPress('ZoneLevel2', event)
                                }} />
                              </Col>
                            </Row>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv3"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                <Field name="ZoneLevel3" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel3" standalone type="text" onKeyPress={(event) => {
                                  this.handleKeyPress('ZoneLevel3', event)
                                }} />
                              </Col>
                            </Row>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv4"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                <Field name="ZoneLevel4" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel4" standalone type="text" onKeyPress={(event) => {
                                  this.handleKeyPress('ZoneLevel4', event)
                                }} />
                              </Col>
                            </Row>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv5"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                <Field name="ZoneLevel5" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel5" standalone type="text" onKeyPress={(event) => {
                                  this.handleKeyPress('ZoneLevel5', event)
                                }} />
                              </Col>
                            </Row>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv6"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                <Field name="ZoneLevel6" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel6" standalone type="text" onKeyPress={(event) => {
                                  this.handleKeyPress('ZoneLevel6', event)
                                }} />
                              </Col>
                            </Row>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv7"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                    <Field name="ZoneLevel7" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel7" standalone type="text" onKeyPress={(event) => {
                                      this.handleKeyPress('ZoneLevel7', event)
                                    }} />
                                  </Col>
                            </Row>
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="zone_lv8"/><span className="dollar-sign">$</span>:</label>
                              </Col>
                              <Col xs={3}>
                                <Field name="ZoneLevel8" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="ZoneLevel8" standalone type="text" onKeyPress={(event) => {
                                  this.handleKeyPress('ZoneLevel8', event)
                                }} />
                              </Col>
                            </Row>
                          {/* End Package Size */}
                        </Panel> {/* End Package Details Panel */}
                      </Col>
                    </Row>
                        }

                    {/* MIX PRODUCT */}
                    {
                      isJML &&
                      <Row>
                        <Col xs={12}>
                          <Panel id="mix-product" header={mixProductPanelHeader}>
                            <div>
                              <Row>
                                <Col xs={12}>
                                <MixProductTypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={4}>
                                  <label style={{ paddingLeft: '0px' }} className="col-xs-4 search-by-max-width">
                                    <Translate value="search_prod"/>
                                  </label>
                                  </Col>
                                  <Col xs={6}>
                                    {this.renderAutoSuggest()}
                                </Col>
                              </Row>
                            </div>
                            <div className="formSubHeaderContainer" style={{ marginTop: '20px' }}>
                              <Row>
                                <Col xs={3}>
                                <p className="formSubHeader">
                                  <Translate value="mix_setting" />
                                </p>
                                </Col>
                              </Row>
                            </div>
                            <div>
                              <Row>
                                <Col sm={2}><input value="1" disabled style={customizedInputStyle} /></Col>
                                <Col sm={3} className="select-menu-drop-up"><Field name="MixedProductBaseUnit" component={Selection} options={packageTypeOptions} /></Col>
                                <Col sm={1} className="textAlignStyle" style={{ fontWeight: 'bold', fontSize: '15px' }}>=</Col>
                              </Row>
                              <Row className="nonbold-label-description textAlignStyle">
                                <Col sm={2}><Translate value="(num)" /></Col>
                                <Col sm={3}><Translate value="(pkg_size)" /></Col>
                              </Row>
                            </div>
                            <div>
                              <Row>
                                <Col xs={12}>
                                {this.renderMixedProduct()}
                                </Col>
                              </Row>
                            </div>
                          </Panel>
                        </Col>
                      </Row>
                    }
                     {/* MIX PRODUCT */}
                  </Col> {/* End Product Details Column */}

                  {/* Cost Details Column */}
                  <Col xs={4}>
                    <Row>
                      <Col xs={12}>
                        {/* Cost Details */}
                        <Panel id="cost-details" style={{height: (isHMM && !checkPermission('view_price_level')) ? '300px' : '500px'}} header={costsDetailsPanelHeader} >
                          <Row>
                            <Col xs={6} className="avg-and-inv-cost">
                              {this.renderAvgCost()}
                            </Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="ref_price"/><span className="asteriksReq">*</span></label>
                                <div className="col-xs-6">
                                  <Field
                                    name="RefPrice"
                                    value={this.props.RefPriceValue}
                                    withRef={true}
                                    ref="RefPrice"
                                    component={ InputField }
                                    disabled={isJML && !checkPermission('change_price_reference')}
                                    normalize={normalizeFourDecimals}
                                    onFocus={this.handleOnFocus}
                                    onChange={(event, newValue, previousValue, name) => {
                                      this.props.setValue('productForm', 'RefPrice', event.target.value);
                                      if(!isEcity) {
                                        const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, event.target.value, this.props.ArrivalPrice);
                                        const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, event.target.value, this.props.ArrivalPrice);
                                        const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, event.target.value, this.props.ArrivalPrice);
                                        const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, event.target.value, this.props.ArrivalPrice);
                                        const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, event.target.value, this.props.ArrivalPrice);
                                        this.setState({
                                          priceLv1,
                                          priceLv2,
                                          priceLv3,
                                          priceLv4,
                                          priceLv5,
                                        });
                                      }
                                    }}
                                    onKeyPress={(event) => { this.handleKeyPress('LowestSalePrice', event)}}
                                  />
                                </div>
                              </div>
                              <div className="form-group mb0">
                                <label className="col-xs-6">
                                  <Translate value="lowest_sale"/><span className="asteriksReq">*</span> <Translate value="dollarsign"/>
                                </label>
                                <div className="col-xs-6">
                                {
                                  isHMM ? 
                                  (checkPermission('hmm_view_arrival') || this.state.permissionChecked) ?
                                  <Field
                                    name="LowestSalePrice"
                                    withRef={true}
                                    ref="LowestSalePrice"
                                    component={InputField}
                                    normalize={normalizeFourDecimals}
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {this.handleKeyPress('LV1', event)}}
                                  />
                                  :
                                  <div onClick={e => this.checkPasscode(e)}>
                                    <input 
                                      disabled
                                      type="text"
                                      placeholder='Click to view'
                                      style={{ borderRadius: '2px', width: '100%', border: '1px solid black', paddingLeft: '2px' }}
                                    />
                                  </div>
                                  :
                                  <Field
                                    name="LowestSalePrice"
                                    withRef={true}
                                    ref="LowestSalePrice"
                                    component={InputField}
                                    normalize={normalizeFourDecimals}
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {this.handleKeyPress('LV1', event)}}
                                  />
                                }
                                </div>
                              </div>
                              {
                                isEcity &&
                                <div className="form-group mb0">
                                  <label className="col-xs-6">
                                    <Translate value="arrival_price"/>
                                  </label>
                                  <div className="col-xs-6">
                                    <input value={ this.props.ArrivalPrice } disabled style={customizedInputStyle}/>
                                  </div>
                                </div>
                              }
                              {
                                ((isHMM && checkPermission('hmm_view_arrival') && !checkPermissionLocal('no_show_product_cost')) || isUSPride || isATL || isRS)&& <div className="form-group mb0">
                                <label className="col-xs-6">
                                  <Translate value="arrival_price"/>
                                </label>
                                <div className="col-xs-6">
                                  <input value={ this.props.ArrivalPrice } disabled style={customizedInputStyle}/>
                                </div>
                              </div>
                              }
                            </Col>
                          </Row>
                          {/* <div className="position-relative">
                            <h3><Translate value="price_level_setup" /></h3>
                            <div className="col-xs-6 col-xs-offset-5" id="price-type">
                              <Field name="PriceType" component={renderPriceTypeRadio}/>
                            </div>
                          </div> */}
                          
                          {
                            (!isHMM || checkPermission('view_price_level')) &&
                            <div className="formSubHeaderContainer">
                              <Row>
                                <Col xs={5} style={{ padding: 0 }}>
                                  <p className="formSubHeader"><Translate value="sales_price_levels" /></p>
                                </Col>
                                <Col xs={7} style={{ padding: 0 }}>
                                  <Field name="PriceType" component={renderPriceTypeRadio} disabled={isJML && !checkPermission('change_price_level')}/>
                                </Col>
                              </Row>
                            </div>
                          }
                          {
                            (!isHMM || checkPermission('view_price_level')) &&
                            <div>
                              <Row>
                                <Col xs={12} className="centerStyle price-level-setup">
                                  <Row>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_1" />%</label>
                                        <div className="col-xs-7">
                                          <Field
                                            name="P1Percentage"
                                            className="control-label"
                                            component={ControlledInputField}
                                            onFocus={this.handleOnFocus}
                                            withRef={true}
                                            ref="LV1"
                                            placeholder={this.state.p1Percentage}
                                            onChange={(event) => { this.handlePercentageChange("p1Percentage", event) }}
                                            onKeyPress={(event) => {this.handleKeyPress('LV2', event)}}
                                            disabled={isJML && !checkPermission('change_price_level')}
                                          />
                                        </div>
                                      </div>
                                      <span className="equal-sign">=</span>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_1" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-7">
                                          <Field name="PriceLv1" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV1_2" placeholder={this.state.priceLv1} onChange={(event) => { this.handlePriceChange("priceLv1", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV2_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={4} className="pull-right">
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_1" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-8">
                                          <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={roundUp(this.state.priceLv1)} />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} className="centerStyle">
                                  <Row>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_2" /> %</label>
                                        <div className="col-xs-7">
                                          <Field name="P2Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV2" placeholder={this.state.p2Percentage} onChange={(event) => { this.handlePercentageChange("p2Percentage", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV3', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                      <span className="equal-sign">=</span>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_2" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-7">
                                          <Field name="PriceLv2" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV2_2" placeholder={this.state.priceLv2} onChange={(event) => { this.handlePriceChange("priceLv2", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV3_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-md-4"><Translate value="lv_2" /><span className="dollar-sign">$</span></label>
                                        <div className="col-md-8">
                                          <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={roundUp(this.state.priceLv2)} />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} className="centerStyle">
                                  <Row>
                                    <Col xs={4} className="level-col-percentages">
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_3" /> %</label>
                                        <div className="col-xs-7">
                                          <Field name="P3Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV3" placeholder={this.state.p3Percentage} onChange={(event) => { this.handlePercentageChange("p3Percentage", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV4', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                      <span className="equal-sign">=</span>
                                    </Col>
                                    <Col xs={4} className="level-col-dollar">
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_3" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-7">
                                          <Field name="PriceLv3" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV3_2" placeholder={this.state.priceLv3} onChange={(event) => { this.handlePriceChange("priceLv3", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV4_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-md-4"><Translate value="lv_3" /><span className="dollar-sign">$</span></label>
                                        <div className="col-md-8">
                                          <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={roundUp(this.state.priceLv3)} />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              {
                                !isEcity && (
                                  <div>
                                    <Row>
                                      <Col xs={12} className="centerStyle">
                                        <Row>
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_4" /> %</label>
                                              <div className="col-xs-7">
                                                <Field name="P4Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV4" placeholder={this.state.p4Percentage} onChange={(event) => { this.handlePercentageChange("p4Percentage", event) }} onKeyPress={(event) => {
                                                  this.handleKeyPress('LV5', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                              </div>
                                            </div>
                                            <span className="equal-sign">=</span>
                                          </Col>
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_4" /><span className="dollar-sign">$</span></label>
                                              <div className="col-xs-7">
                                                <Field name="PriceLv4" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV4_2" placeholder={this.state.priceLv4} onChange={(event) => { this.handlePriceChange("priceLv4", event) }} onKeyPress={(event) => {
                                                  this.handleKeyPress('LV5_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                              </div>
                                            </div>
                                          </Col>
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-md-4"><Translate value="lv_4" /><span className="dollar-sign">$</span></label>
                                              <div className="col-md-8">
                                                <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={roundUp(this.state.priceLv4)} />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col xs={12} className="centerStyle">
                                        <Row>
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_5" /> %</label>
                                              <div className="col-xs-7">
                                                <Field name="P5Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV5" placeholder={this.state.p5Percentage} onChange={(event) => { this.handlePercentageChange("p5Percentage", event) }} onKeyPress={(event) => {
                                                  this.handleKeyPress('LV1_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
                                              </div>
                                            </div>
                                            <span className="equal-sign">=</span>
                                          </Col>
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_5" /><span className="dollar-sign">$</span></label>
                                              <div className="col-xs-7">
                                                <Field
                                                  name="PriceLv5"
                                                  className="control-label"
                                                  component={ControlledInputField}
                                                  onFocus={this.handleOnFocus}
                                                  withRef={true}
                                                  ref="LV5_2"
                                                  placeholder={this.state.priceLv5}
                                                  onChange={(event) => { this.handlePriceChange("priceLv5", event) }}
                                                  onKeyPress={(event) => {
                                                    if (event.charCode === 13) {
                                                      event.preventDefault();
                                                      this.refs["CRVOptions"].getRenderedComponent().refs.select.focus();
                                                    }
                                                  }}
                                                  disabled={isJML && !checkPermission('change_price_level')}
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-md-4">
                                                <Translate value="lv_5" />
                                                <span className="dollar-sign">$</span>
                                              </label>
                                              <div className="col-md-8">
                                                <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={roundUp(this.state.priceLv5)} />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </div>
                                )
                              }
                              <div className="formDivider"></div>
                            </div>
                          }
                          {/* Per Michael: Do not include for demo
                          <Row>
                            <Col xs={ 12 } className="centerStyle">
                              <Field name="RoundPriceLevels" labelName="is_two_decimal" component={ renderRadios } />
                            </Col>
                          </Row> */}
                          <Row className="formRow">
                            <Col xs={3}>
                              <label><Translate value="taxable" /></label>
                            </Col>
                            <Col xs={3}>
                              <Field
                                name="IsTaxable"
                                // disabled={(isAN && this.props.IsAllTaxable)}
                                component={Checkbox}
                              />
                            </Col>
                            {
                              isAN &&
                              <div>
                                <Col xs={3}>
                                  <label><Translate value="all_taxable" /></label>
                                </Col>
                                <Col xs={3}>
                                  <Field name="IsAllTaxable" component={Checkbox} />
                                </Col>
                              </div>
                            }
                            {
                              (isEcity || isGS )&&
                              <div>
                                <Col xs={3}>
                                  <label><Translate value="non_food" /></label>
                                </Col>
                                <Col xs={3}>
                                  <Field name="IsNonFood" component={Checkbox} />
                                </Col>
                              </div>
                            }
                          </Row>
                          <Row className="formRow">
                            <Col xs={3}>
                              <label><Translate value="CRV" /></label>
                            </Col>
                            <Col xs={9}>
                              {this.CRV()}
                            </Col>
                          </Row>
                        </Panel> {/* Cost Details Column */}
                      </Col>
                    </Row>

                    <Panel id="sale-details" header={saleDetailsPanelHeader}> {/* Sale */}
                      {
                        isEcity &&
                        <Row>
                          <Col xs={12}>
                            <Button
                              bsStyle="primary"
                              style={{ position: 'absolute', top: '-50px', right: '0px' }}
                              type="button"
                              onClick={() => { this.openESLModal(); }}
                              disabled={(!this.props.currentProduct && !this.props.params.id) || !this.state.eslEnabled}
                            >
                              <Translate value="ESL" />
                            </Button>
                          </Col>
                        </Row>
                      }

                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="stop_sale"/></label>
                            </Col>
                            <Col xs={5}>
                             <Field name="IsStopSale" component={Checkbox} />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="oversaleable"/></label>
                            </Col>
                            <Col xs={5}>
                              <Field name="IsOverSaleable" component={Checkbox} disabled={this.props.IsStopSale} />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="wholesale_only"/></label>
                            </Col>
                             <Col xs={5}>
                               <Field name="IsWholesaleOnly" component={Checkbox} disabled={this.props.IsStopSale} />
                             </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="mobile_sale"/></label>
                            </Col>
                            <Col xs={5}>
                              <Field name="IsMobile" component={Checkbox} disabled={this.props.IsStopSale} />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      {
                        isAFM &&
                        <Row className="formRow">
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="top_deal"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsGreatDeal" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="new_arrival"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsNewArrival" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="nationwide"/></label>
                            </Col>
                             <Col xs={5}>
                               <Field name="IsSoldNationwide" component={Checkbox} disabled={this.props.IsStopSale} />
                             </Col>
                          </Row>
                        </Col>
                        {
                          (isAFG || isMyuMyu || isWecom) &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="Proposition65" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsProposition65" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }
                      </Row>
                      {
                        isHF &&
                        <Row className="formRow">
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="IsB2B" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsB2B" component={Checkbox} disabled={this.props.IsB2B} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="IsB2C" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsB2C" component={Checkbox} disabled={this.props.IsB2C} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                      <Row className="formRow">
                        {
                          (isEcity || isGS) &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="sync_scale" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsSyncToScales" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          (isGS) &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="tare" /></label>
                              </Col>
                              <Col xs={5}>
                                {/* <Field name="Tare" component={Checkbox} disabled={this.props.IsStopSale} /> */}
                                <Field name="Tare" withRef={true} ref="Tare" component={ InputField } onKeyPress={(event) => {
                                      
                                  }}/>
                              </Col>
                            </Row>
                          </Col>
                        }
                         {
                          isEcity &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="sync_esl" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsSyncToESL" component={this.ESLCheckbox} disabled={this.props.IsStopSale || ((!this.props.currentProduct && !this.props.params.id))} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          isAFG &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="afg_choice" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsAFGChioce" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }    
                        {
                          isAFG &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="alcohol" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsAlcohol" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }
                      </Row>
                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={8}>
                              <label><Translate value="limit_qty_order" /></label>
                            </Col>
                            <Col xs={4}>
                              <Field placeholder='0' name="LimitQuantityPerOrder" component={InputField} />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Col xs={8}>
                              <label><Translate value="limit_qty_order_desc" /></label>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className="formDivider"></div>
                      <Row className="formRow">
                        <Col xs={3}>
                          <label><Translate value="default_sales" /></label>
                        </Col>
                        <Col xs={9}>
                          {this.defaultSales()}
                        </Col>
                      </Row>
                      <Row className="formRow">
                        <Col xs={12}>
                          <label><Translate value="enable_for_languages" /></label>
                        </Col>
                        <Col xs={12}>
                          <Field
                            multi
                            removeSelected
                            simpleValue
                            closeOnSelect={false}
                            name="ViewableLanguages"
                            component={SelectionWithProps}
                            options={languages}
                            placeholder={I18n.t('enable_for_language')}
                          />
                        </Col>
                      </Row>
                    </Panel>
                    {/* End Sale */}
                    <Panel id="buyer-details" header={buyerDetailsPanelHeader}>
                      <Row className="formRow">
                        <Col xs={12}>
                          <Row>
                            <Col xs={4}>
                              <label><Translate value="stop_purchase"/></label>
                            </Col>
                            <Col xs={8}>
                              <Field name="IsStopPurchase" component={ Checkbox } />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className="formDivider"></div>
                      <Row className="formRow">
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={4}>
                              <label><Translate value="default_purchaser"/></label>
                            </Col>
                            <Col xs={8}>
                              {this.renderDefaultBuyers()}
                            </Col>
                          </div>
                        </Col>
                      </Row>
                    </Panel> {/* End Buyer Details */}
                  </Col> {/* End Cost Details Column */}
                  {/* Convert Details Column */}
                  <Col xs={4}>
                    {
                      // !isHMM &&
                      true &&
                    <Row>
                      <Col xs={12}>
                        {/* Convert Details */}
                        <Panel id="convert-details" header={convertDetailsPanelHeader}>
                          <Row>
                            <Col xs={12}>
                              <Row>
                                <Col xs={12}>
                                  <Field name="ConvertType" component={convertNumRadios} />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12}>
                                  <div className="form-group">
                                    {!isTN && <label className="col-xs-5"><Translate value="convert_prod_qty" /></label>}
                                    {isTN && <label className="col-xs-5"><Translate value="purchase_convert_unit" /></label>}
                                    <div className="col-xs-7 convert-prod-qty">
                                      {/* of */}
                                      <Field name="ConvertNum" component={DisabledInputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12}>
                                  <div className="form-group">
                                    {!isTN && <label className="col-xs-5"><Translate value="purchase_convert_unit" /></label>}
                                    {isTN && <label className="col-xs-5"><Translate value="sales_convert_unit" /></label>}
                                    <div className="col-xs-7 convert-prod-qty">
                                      {/* of */}
                                      <Field name="PurchaseConvertUnit" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            {/* Prod No & Qty Label / Input Group */}
                            {this.renderConvertDetails()}
                          </Row>
                        </Panel> {/* End Convert Details */}
                      </Col>
                    </Row>
                    }

                    {/* Inventory Details */}
                    <Panel id="inventory-details-panel" header={inventoryDetailsPanelHeader}>
                      <Row>
                      {
                        isTQ &&
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="hmart_code"/></label>
                            </Col>
                            <Col xs={7}>
                              <Field name="InternalBarcode" withRef={true} ref="InternalBarcode" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                  this.handleKeyPress('UnitPerPallet', event)
                              }}/>
                            </Col>
                          </div>
                        </Col>
                      }
                      {
                        (isUSPride) &&
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="warehouse"/></label>
                            </Col>
                            <Col xs={7}>
                            <Field name="Default_Warehouse_id" component={Selection} options={this.state.warehouseOptions}/>
                            </Col>
                          </div>
                        </Col>
                      }
                      {
                        !isTQ && 
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="internal_barcode"/></label>
                            </Col>
                            <Col xs={7}>
                              <Field name="InternalBarcode" withRef={true} ref="InternalBarcode" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                this.handleKeyPress('UnitPerPallet', event)
                              }}/>
                            </Col>
                          </div>
                        </Col>
                      } 
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="per_pallet" /></label>
                            </Col>
                            <Col xs={7}>
                              <Field name="UnitPerPallet" className="control-label" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="UnitPerPallet" onKeyPress={(event) => {
                                  this.handleKeyPress('MinStockRange', event)
                                }}
                              />
                            </Col>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                          <label><Translate value="stock_range" /></label>
                        </Col>
                        <Col xs={3}>
                          <Row>
                            <Col xs={4}>
                              <label><Translate value="min" /></label>
                            </Col>
                            <Col xs={8}>
                              <Field
                                name="MinStockRange"
                                withRef={true}
                                ref="MinStockRange"
                                component={InputField}
                                onFocus={this.handleOnFocus}
                                onKeyPress={(event) => {
                                  this.handleKeyPress('MaxStockRange', event)
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={1} style={{textAlign: 'center'}}>
                          <label><Translate value="~" /></label>
                        </Col>
                        <Col xs={3}>
                          <Row>
                            <Col xs={4}>
                              <label><Translate value="max" /></label>
                            </Col>
                            <Col xs={8}>
                              <Field name="MaxStockRange" withRef={true} ref="MaxStockRange" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                  this.handleKeyPress('Zone', event)
                              }}/>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <h3 style={{marginBottom: '10px'}}><Translate value="location" /></h3>
                      {
                        isEcity &&
                      <Col xs={12}>
                        <Col sm={8}>
                        <label><Translate value="zone" /></label>
                        <Field name="Zone" component={InputField} />
                        </Col>
                      </Col>
                      }
                      {
                        (!isEcity && !isAFM) &&
                      <Col xs={12}>
                        <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{width: 120}}>
                          <label><Translate value="zone" /></label>
                          <Field name="Zone" component={Selection} options={getZoneOptions} disabled={!this.props.zones}/>
                        </Col>
                        <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{width: 120}}>
                          <label><Translate value="bin" /></label>
                          <Field
                            name="Bin"
                            component={Selection}
                            options={getBinOptions}
                            disabled={!this.props.Zone}
                          />
                        </Col>
                        <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{width: 120}}>
                          <label><Translate value="level" /></label>
                          <Field
                            name="Level"
                            component={Selection}
                            options={getLevelOptions}
                            disabled={!this.props.Bin}
                          />
                        </Col>
                      </Col>
                      }
                      {
                        isAFM &&
                        <div>
                        <Col xs={12} style={{ marginTop: '5px' }}>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label>Bellevue</label>
                            <Field name="Zone" component={Selection} options={getZoneOptions} disabled={!this.props.zones} />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin" /></label>
                            <Field
                              name="Bin"
                              component={Selection}
                              options={getBinOptions}
                              disabled={!this.props.Zone}
                            />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level" /></label>
                            <Field
                              name="Level"
                              component={Selection}
                              options={getLevelOptions}
                              disabled={!this.props.Bin}
                            />
                          </Col>
                        </Col>
                        <Col xs={12} style={{ marginTop: '5px' }}>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label>Beaverton</label>
                            <Field name="Zone2" component={Selection} options={getZoneOptions} disabled={!this.props.zones} />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin" /></label>
                            <Field
                              name="Bin2"
                              component={Selection}
                              options={getBin2Options}
                              disabled={!this.props.Zone2}
                            />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level" /></label>
                            <Field
                              name="Level2"
                              component={Selection}
                              options={getLevel2Options}
                              disabled={!this.props.Bin2}
                            />
                          </Col>
                        </Col>
                        <Col xs={12} style={{ marginTop: '5px' }}>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label>Seattle</label>
                            <Field name="Zone3" component={Selection} options={getZoneOptions} disabled={!this.props.zones} />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin" /></label>
                            <Field
                              name="Bin3"
                              component={Selection}
                              options={getBin3Options}
                              disabled={!this.props.Zone3}
                            />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level" /></label>
                            <Field
                              name="Level3"
                              component={Selection}
                              options={getLevel3Options}
                              disabled={!this.props.Bin3}
                            />
                          </Col>
                        </Col>
                        </div>
                      }
                      {
                        isMMD &&
                        <Col xs={12} style={{ position: 'relative', marginTop: 20}}>
                          <Row>
                            <Col xs={3}>
                                <label>Auto PO</label>
                            </Col>
                            <Col xs={1}>
                              <Field name="AutoPO" component={ Checkbox } />
                            </Col>
                            <Col xs={4}>
                              <p style={{fontWeight: "bold", position: "relative"}}>Auto PO Qty</p>
                            </Col>
                            <Col xs={2} style={{ paddingLeft: 10 }}>
                              <Field
                                name="default_po_quantity"
                                component={ InputField }
                              />
                            </Col>
                          </Row>
                        </Col>
                      }
                      <Col xs={12} style={{ position: 'relative', marginTop: 20}}>
                        <Row>
                          <Col xs={2} style={{ paddingRight: 0 }}>
                            <label><Translate value="shelf_life" /></label>
                          </Col>
                          <Col xs={2} style={{ paddingLeft: 10 }}>
                            <Field
                              name="ShiftLife"
                              withRef={true}
                              ref="ShelfLife"
                              component={ InputField }
                              onFocus={this.handleOnFocus}
                              onKeyPress={(event) => {
                                if (event.charCode === 13)
                                  event.preventDefault();
                                }}
                              />
                          </Col>
                          <Col xs={1}>
                            <p style={{fontWeight: "bold", position: "relative", left: "-10px"}}><Translate value="days" /></p>
                          </Col>
                          <Col xs={1}></Col>
                          {
                            isEcity &&
                            <Row>
                              <Col xs={3} style={{ paddingRight: 0 }}>
                                <label><Translate value="expire_date" /></label>
                              </Col>
                              <Col xs={3} style={{ paddingLeft: 0 }}>
                                <Field
                                  disabled={true}
                                  name="ShiftLifeTime"
                                  withRef={true}
                                  ref="ShelfLife"
                                  component={InputField}
                                />
                              </Col>
                            </Row>
                          }
                        </Row>
                      </Col>
                      {
                        isFACEX &&
                        <Col xs={12} style={{ position: 'relative', marginTop: 20}}>
                          <Row>
                            <Col xs={4}>
                              <p style={{fontWeight: "bold", position: "relative"}}>Inventory QTY: </p>
                            </Col>
                            <Col xs={3} style={{ paddingLeft: 10 }}>
                              <Input 
                                type="text"
                                name="qty"
                                value={this.state.productInventoryQty}
                                onFocus={this.handleOnFocus}
                                onChange={(e) => {
                                  this.setState({ productInventoryQty: e.target.value });
                                }}
                              />
                            </Col>
                            <Col xs={3} style={{ paddingLeft: 10 }}>
                              <Button
                                bsStyle="primary"
                                type="button"
                                onClick={() => this.props.postProductInventoryBatches(this.props.params.id, this.state.productInventoryQty) }
                              >
                                <em className="fa fa-save" />
                                <Translate value="modify_inventory" />
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      }
                    {/* </Row> */}
                    </Panel> {/* End Inventory Details */}

                    <Row>
                      <Col xs={12}>
                        {/* Vendor Details */}
                        <Panel id="vendor-details" header={vendorPanelHeader}>
                          {this.renderVendors() }
                        </Panel> {/* End Vendor Details */}
                      </Col>
                    </Row> {/* Vendor Details */}
                  </Col> {/* End Convert Details */}

                </Row> {/* Row Wrapper */}
              </Grid>
            </div>
          </form>
          {/* <div>{ this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }</div> */}
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.deleteModalOpen}
            onCloseClicked={this.closeDeleteModal}
            title={deleteProduct}
          >
            <ConfirmActionModal
              case="confirmPassword"
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
          <SkyLightStateless isVisible={this.state.vendorOpen} onCloseClicked={() => { this.closeVendor() } } title="Add A New Vendor">
            <VendorForm closeV={this.closeVendor} />
          </SkyLightStateless>
          <SkyLightStateless isVisible={this.state.groupOpen} onCloseClicked={() => { this.closeGroup() } } title="Add A New Group">
            <GroupForm closeG={this.closeGroup} />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editProductGroup} onCloseClicked={() => { this.closeProductGroupEdit() }} title={editGroupFormTitle}>
            <EditGroupForm
              closeG={this.closeProductGroupEdit}
              groups={this.props.groups}
              formContent={this.state.editGroupFormAction === 'changeGroup' && this.state.productNavigation_1}
              productId={this.props.currentProductDetail && this.props.currentProductDetail.Product_id}
              saveAction={editGroupFormSaveAction}
              saveCallback={editGroupFormSaveActionCallback}
            />
          </SkyLightStateless>
          <SkyLightStateless isVisible={this.state.categoryOpen} onCloseClicked={() => { this.closeCategory() } } title="Create a new category">
              <CategoryForm closeC={this.closeCategory} type="productForm"/>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.showProductCreatedOpen}
            onCloseClicked={this.closeShowProductCreated.bind(this)}
          >
            <br /><br />
            <Row className="centerStyle">
              <h4><Translate value="product_saved"/></h4>
            </Row>
            <br />
            <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" />?</h4></Row>
            <br /><br />
            <Row className="centerStyle">
              <Button bsStyle="primary" onClick={(event) => { this.refreshPage(event) }} type="button" ><Translate value="yes"/></Button>
              { this.renderCloseButton() }
            </Row>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.productNavigationOpen[0]} onCloseClicked={() => { this.closeNavigation() } }>
            <ProductFormNavigation_1
              groups = {this.props.groups}
              handleClickNext={this.handleClickNext_1}
              formContent={this.state.productNavigation_1}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.productNavigationOpen[1]} onCloseClicked={() => { this.closeNavigation() } }>
            <ProductFormNavigation_2 handleClickPrev={this.handleClickPrev_2} handleClickNext={this.handleClickNext_2} formContent={this.state.productNavigation_2}/>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.productNavigationOpen[2]} onCloseClicked={() => { this.closeNavigation(); } }>
            <ProductFormNavigation_3
              handleClickPrev={this.handleClickPrev_3}
              closeNavigation={this.closeNavigation}
              saveProductFormNavigation_3={this.saveProductFormNavigation_3}
              formContent={this.state.productNavigation_3}
              ProductNum={this.state.productNavigation_1.ProductNum}
              ProductGroup_id={this.state.productNavigation_1.ProductGroup_id}
              ProductCategory1_id={this.state.productNavigation_1.ProductCategory1_id}
              suggestedProdNum={this.state.productNavigation_1.suggestedProdNum}
              LastDigit={this.state.productNavigation_1.LastDigit}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.packageTypeOpen} onCloseClicked={() => { this.closePackageType() } }>
            <PackageTypes selectPackageType={this.selectPackageType} />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={promotionsStyle || this.state.isLoadingSavePromotion}
            isVisible={this.state.viewPromotion}
            onCloseClicked={this.closeViewPromotion}
            title={viewPromotionHeader}
          >
            <div id="promotions-page" className="centerStyle">
              <Row>
                <Tabs activeKey={this.state.tabsKey} justified onSelect={this.handleTabSelect}>
                  { this.renderByQuantityTab() }
                  {/* { this.renderBuyAGetBTab() } */}
                  { this.renderByTotalPriceProductTab() }
                  {/* { this.renderByTotalPriceDiscountTab() } */}
                </Tabs>
              </Row>
              <Row>
                {this.renderPromoDetails()}
              </Row>
            </div>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.editRecPermissionOpen}
            onCloseClicked={() => { this.closeEditRecPermission(); }}
            title={editRecPermission}
          >
            <ConfirmActionModal
              case={this.state.case}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={deletePromotionDialogStyle}
            isVisible={this.state.deletePromotionOpen}
            onCloseClicked={this.closeDeletePromotion}
          >
            <ConfirmActionModal
              case="removeItem"
              closeC={this.closeDeletePromotion}
              caseAction={this.handleDeletePromotion}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={editPromotionDialog}
            isVisible={this.state.editPromotionOpen}
            onCloseClicked={() => this.closeEditPromotion()}
            title={editPromotionTitle}
          >
            <EditPromotionModal
              promotion={this.state.promotionToEdit}
              customerList={this.state.customerList}
              closeEditPromotion={this.closeEditPromotion}
              isLoadingPromoDetails={this.state.isLoadingPromoDetails}
              searchProduct={false}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.checkAuthorizeOpen}
            onCloseClicked={this.closeCheckAuthorize}
          >
            <ConfirmActionModal
              case='confirmPassword'
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
          {renderRichTextEditor()}
          <SkyLightStateless
            dialogStyles={createDisplayCategoryDialogStyle}
            isVisible={this.state.displayCategoryBoxOpen}
            onCloseClicked={() => { this.closeDisplayCategoryBox(); }}
            title={displayCategoryBoxTitle}
          >
            <DisplayCategoryModal displayCategories={this.state.displayCategories} productId={this.props.params.id} editDisplayCategories={this.props.editDisplayCategories} closeModal={this.closeDisplayCategoryBox} getDisplayCategories={this.getDisplayCategories}/>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.skusModal}
            onCloseClicked={() => { this.closeSkusModal(); }}
            title={skusModalTitle}
          >
            <SkusTableModal
              close={this.closeSkusModal}
              skus={this.state.ProductSKU}
              updateSKU={this.updateSKU}
              Product_id={this.state.Product_id}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={imagesModalStyle}
            isVisible={this.state.imagesModalOpen}
            onCloseClicked={this.closeImageModal}
            title={imagesModalTitle}
          >
            <ProductImagesTable
              productId={this.props.currentProductDetail && this.props.currentProductDetail.Product_id}
              handleImageUpdated={(image) => this.handleImageUpdated(image)}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={convertProductListStyle}
            isVisible={this.state.addConvertProductsOpen}
            onCloseClicked={() => this.closeAddConvertProducts()}
            title={addConvertProductsTitle}
          >
            <LinkProductsModal
              products={this.state.categoryProducts}
              previouslySelectedProducts={this.state.relatedProducts}
              modifyConvertableProductList={this.modifyConvertableProductList}
            />
          </SkyLightStateless>
          <SkyLightStateless title={productMetaInfoTitle} dialogStyles={createProductMetaStyle} isVisible={this.state.productMetaInfoVisibility} onCloseClicked={() => { this.setProductMetaInfoVisibility(false) }}>
            <ProductMetaInfoModal meta_info={this.state.meta_info} handleProductMetaInfoSave={this.handleProductMetaInfoSave} />
          </SkyLightStateless>

          <SkyLightStateless title={eslTitle} dialogStyles={createESLStyle} isVisible={this.state.eslModalVisibility} onCloseClicked={() => { this.closeESLModal(); }}>
            <ESLModal eslFetchData={this.state.eslFetchData} fetchESLTemplate={this.props.fetchESLTemplate} handleSaveESL={this.handleSaveESL} handleFetchESL={this.handleFetchESL} />
          </SkyLightStateless>

          <ConfirmModal 
             title={<Translate value="Action Confirmation" />}
             content={<Translate value="Warning: Shipping Weight is lower then Net Weight" />} 
             onConfirm={() => {
              this.setState({ confirmModalVisibility: false });
              this.submitForm(this.state.formProps);
            }} 
             onCancel={() => { this.setState({confirmModalVisibility: false }) }} 
             isVisible={this.state.confirmModalVisibility}
          />
        </ContentWrapper>
        //---------------
        // End HTML
        //---------------
      )
    }
  }
}

export default withRouter(ProductForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Products/productForm.jsx